/* eslint-disable no-unmodified-loop-condition */
/* eslint-disable handle-callback-err */
<template>
  <v-app>
    <v-app-bar v-if="VIEW === 'BATCH_SCAN' || VIEW === 'BATCH_LIST' || VIEW === 'JSON_GENERATOR'" app color="primary" dark height="96px">
      <div class="d-flex align-center">
        <v-img v-if="!isFireFox" alt="" class="shrink mr-2 svgfill"  contain :src="LOGO" transition="scale-transition" width="150" />
        <v-img v-if="isFireFox" alt="" class="shrink mr-2 svgfill"  contain :src="LOGO" transition="scale-transition" width="150" height="96" />
      </div>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn @click="openWs()" v-on="on" text>
            <v-icon v-show="wsConnected" color="green">mdi-circle-multiple</v-icon>
            <v-icon v-show="!wsConnected" color="pink">mdi-circle-multiple-outline</v-icon>
          </v-btn>
        </template>
        <span>{{ wsConnected ? $t('app.wsstatusc') : $t('app.wsstatusd') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn color="warning" @click="onClickRun" v-on="on" text v-show="OS === 'Windows' && !wsConnected">
            <v-icon>mdi-application</v-icon>
            {{$t('app.run')}}
          </v-btn>
        </template>
        <span>{{$t('app.run')}}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn color="warning" @click="onClickDownload" v-on="on" text v-show="OS === 'Windows' && !wsConnected">
            <v-icon>mdi-download-circle</v-icon>
            {{$t('app.download')}}
          </v-btn>
        </template>
        <span>{{$t('app.download')}}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn color="warning" @click="onClickDownload" v-on="on" text v-show="OS === 'Windows' && wsConnected && tooltipVersion">
            <v-icon>mdi-download-circle</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('app.newversion') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn :disabled="isDisbale || tempDisabled" @click="documentIndex.indexesBoard = !documentIndex.indexesBoard; twain.ScanBoard = false" v-on="on" text>
            <v-icon>mdi-developer-board</v-icon>
          </v-btn>
        </template>
        <span>{{$t('app.indexpanel')}}</span>
      </v-tooltip>
      <!-- <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn @click="clickChangeGridSize(0)" text :disabled="tempDisabled" v-on="on">
            <v-icon>mdi-grid</v-icon>
          </v-btn>
        </template>
        <span>{{$t('app.smallthumb')}}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn @click="clickChangeGridSize(1)" text :disabled="tempDisabled" v-on="on">
            <v-icon>mdi-grid-large</v-icon>
          </v-btn>
        </template>
        <span>{{$t('app.largethumb')}}</span>
      </v-tooltip> -->

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text :disabled="tempDisabled" v-on="on" v-bind="attrs">
            <!-- <v-icon>mdi-grid</v-icon> -->
            <v-icon>mdi-loupe</v-icon>
          </v-btn>
        </template>
        <v-card width="250px" style="padding-top: 10px;">
          <v-card-text>
            <v-slider v-model="thumbCols" ticks max="6" min="1"></v-slider>
          </v-card-text>
        </v-card>
      </v-menu>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn @click="clickCreateBatch" text v-on="on" v-show="!batchTypes.Current.BatchSettings.Quick">
            <v-icon>mdi-folder-plus</v-icon>
          </v-btn>
        </template>
        <span>{{$t('app.createbatch')}}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-show="mobileScanSettings.length > 0" @click="loadMobileScan(true)" text v-on="on" :disabled="tempDisabled">
            <v-icon>mdi-file-refresh</v-icon>
          </v-btn>
        </template>
        <span>{{$t('app.mobilescan_refresh')}}</span>
      </v-tooltip>
      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-show="mondayContext !== null" @click="clickExportBatchToMonday" text v-on="on" :disabled="isDisbale || tempDisabled">
            <v-icon>$vuetify.icons.mondayicon</v-icon>
          </v-btn>
        </template>
        <span>{{ (mondayContext !== null && monday.item.itemId !== '') ? $t('app.monday_to_pulse') : $t('app.monday_to_group')}}</span>
      </v-tooltip>

      <!-- MFILES BUTTON -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn @click="clickExportBatchMFiles" v-show="!dataTypes.isNullOrEmpty(batchTypes.Current.EndpointMFiles.BaseUrl)" :disabled="isDisbale || tempDisabled" v-on="on" text>
            <v-icon>$vuetify.icons.mfilesicon</v-icon>
          </v-btn>
        </template>
        <span>{{$t('app.exportbatchmfiles')}}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn @click="clickExportBatchEndpointPrompt" v-show="isExportEndPoint" :disabled="isDisbale || tempDisabled || !isExportEndPoint" v-on="on" text>
            <v-icon>mdi-upload-network</v-icon>
          </v-btn>
        </template>
        <span>{{$t('app.exportbatchendp')}}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-show="(batchTypes.Current.BatchSettings.Quick && !exportFolderExist) ? false : true" :disabled="isDisbale || tempDisabled" @click="clickBatchExport" v-on="on" text>
            <v-icon>mdi-table-arrow-right</v-icon>
          </v-btn>
        </template>
        <span>{{$t('app.batchexport')}}</span>
      </v-tooltip>
       <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-show="!batchTypes.Current.BatchSettings.Quick" @click="uploadBatchSim" :disabled="isDisbale || tempDisabled || !uploadValid.valid" v-on="on" text>
            <v-icon>mdi-folder-upload</v-icon>
          </v-btn>
        </template>
        <span>{{$t('app.uploadbatch')}}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn :disabled="isDisbale || tempDisabled" @click="changeScanType(IModels.VIEW_SCAN_TYPE.QUICK_SCAN)" v-on="on" text>
            <v-icon>mdi-scanner</v-icon>
          </v-btn>
        </template>
        <span>{{$t('app.scan')}}</span>
      </v-tooltip>
      <v-menu bottom left :style="(isIE11) ? 'min-width:200px !important;' : ''">
        <template v-slot:activator="{ on }">
          <v-btn v-show="!batchTypes.Current.BatchSettings.Quick" dark icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list :style="(isIE11) ? 'min-width:200px !important;' : ''">
          <v-list-item v-for="(item, i) in mainMenuItems" :key="i" @click="clickMainMenu(item)">
            <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-progress-linear absolute bottom :indeterminate="mobileLoading" v-show="mobileLoading" color="amber darken-2"></v-progress-linear>
    </v-app-bar>
    <v-navigation-drawer color="primary accent-4" width="350" v-model="documentIndex.indexesBoard" app dark left fixed disable-resize-watcher>
      <v-list>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">
            {{$t('app.docindex')}}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{(documentIndex.doc === null) ? '' : documentIndex.doc.Name}}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-divider></v-divider>
      <v-card color="primary accent-4" elevation="0" tile>
        <v-form ref="indexesForm">
        <v-col cols="12" v-for="di in documentIndexes" :key="di.Id">
          <v-text-field v-if="di.DataType !== 'Date'" :disabled="isDisbale"  :label="(di.Caption.length === 0) ? di.Name : di.Caption" v-model="di.Value" @change="changeIndexesValue" :required="di.Mandatory" :rules="getIndexesRules(di)"></v-text-field>
          <DateField v-if="di.DataType === 'Date'" :disabled="isDisbale" :di="di" @change="changeIndexesValue" :rules="getIndexesRules(di)"></DateField>
        </v-col>
        </v-form>
      </v-card>
    </v-navigation-drawer>
    <v-navigation-drawer class="primary accent-4" width="350" v-model="twain.ScanBoard" app dark right fixed disable-resize-watcher>
      <v-card class="primary accent-4" elevation="0" tile>
        <v-col :cols="12">
          <v-form :disabled="!is64Bit || !wsConnected || isDisbale" v-show="VIEW_SCAN.type === IModels.VIEW_SCAN_TYPE.QUICK_SCAN" ref="quickForm">
            <v-btn light color="#cecece" v-show="scanVisible" :disabled="!wsConnected" block rounded @click="clickQuickScanBoard">{{$t('app.sform.scan')}}</v-btn>
            <br/>
            <!-- <v-file-input :disabled="!is64Bit || !wsConnected || isDisbale" id="fileUploaderInput" ref="fileUploader" accept="image/tif,image/tiff,application/pdf,*.tif,*.pdf,image/jpg,image/jpeg,*.jpg,*.jpeg,image/png,*.png,image/bmp,*.bmp,image/gif,*.gif,text/xml,*.xml" :value="fileInputValue" :rules="[() => !!fileExtractData || $t('app.iform.selectfilerule')]" :loading="fileExtractLoading" show-size chips :label="$t('app.iform.selectfile')" @change="changeFileSelect" required multiple validate-on-blur clearable></v-file-input> -->
            <v-file-input :disabled="!is64Bit || !wsConnected || isDisbale" id="fileUploaderInput" ref="fileUploader" :accept="AllowedExtensions" :value="fileInputValue" :rules="[() => !!fileExtractData || $t('app.iform.selectfilerule')]" :loading="fileExtractLoading" show-size chips :label="$t('app.iform.selectfile')" @change="changeFileSelect" required multiple validate-on-blur clearable></v-file-input>
            <!-- <Attachments v-show="batchTypes.Current.ApplicationSettings.ImportSettings.Attachments" :disabled="!is64Bit || !wsConnected || isDisbale" @onChange="updateBatchInStorage" :label="$t('json.addattachment')" :batch="batch" :multiple="true" :hideinput="true" :accept="'*'"></Attachments> -->
            <v-row v-show="importFolderExist" align="center" style="margin:0;">
              <v-col cols="6">
              <v-checkbox  :disabled="!wsConnected || isDisbale" v-show="importFolderExist"  v-model="importFolderCheckBox" :label="$t('app.iform.importfolder')" @change="changeImportFolderCheckBox"></v-checkbox>
              </v-col>
              <v-col cols="6">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-show="importFolderExist" v-on="on">mdi-information</v-icon>
                  </template>
                  <span>{{ importFolderPath }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-btn light color="#cecece" v-for="DocClass in this.batchTypes.Current.BatchSettings.Classes" :key="DocClass.Name" :disabled="!is64Bit || !wsConnected || isDisbale" block rounded @click="clickQuickScanBoard(null, DocClass)" style="margin-top:5px;">{{ DocClass.Name }}</v-btn>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn :disabled="!wsConnected || isDisbale" @click="twain.ScanBoardSettings = !twain.ScanBoardSettings" icon v-on="on"><v-icon>mdi-cog</v-icon></v-btn>
              </template>
              <span>{{ $t('app.sform.advancedsettings') }}</span>
            </v-tooltip>
          </v-form>
        </v-col>
      </v-card>
    </v-navigation-drawer>
    <v-navigation-drawer class="primary accent-4" width="350" v-model="twain.ScanBoardSettings" dark right fixed temporary disable-resize-watcher>
      <v-form ref="scanForm">
        <v-card class="primary accent-4" elevation="0" tile>
          <v-col cols="12">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn @click="twain.ScanBoardSettings = !twain.ScanBoardSettings" icon v-on="on"><v-icon>mdi-arrow-expand-right</v-icon></v-btn>
                </template>
                <span>{{$t('app.sform.closesett')}}</span>
              </v-tooltip>
              <v-switch :disabled="!wsConnected || isDisbale" @change="(v) => { if(v) { this.changeSeparator('circlestamp') } else { this.changeSeparatorFalse(v) }}"  v-model="ScanSettings.AutoSeparator" :label="$t('app.sform.cseparator')"></v-switch>
              <v-switch :disabled="!wsConnected || isDisbale" @change="(v) => { if(v) { this.changeSeparator('singlepage') } else { this.changeSeparatorFalse(v) }}" :label="$t('app.sform.aseparatorspd')" v-model="ScanSettings.AutoSinglePageDocuments"></v-switch>
              <v-switch :disabled="!wsConnected || isDisbale" @change="(v) => { if(v) { this.changeSeparator('file') } else { this.changeSeparatorFalse(v) }}" :label="$t('app.sform.fseparator')" v-model="ScanSettings.FileSeparator"></v-switch>
              <v-switch :disabled="!wsConnected || isDisbale" @change="(v) => { if(v) { this.changeSeparator('barcode') } else { this.changeSeparatorFalse(v) }}" v-model="ScanSettings.BarcodeSeparator" :label="$t('app.sform.bseparator')"></v-switch>
              <v-switch :disabled="!wsConnected || isDisbale" v-model="ScanSettings.DoubleDetection" v-show="ScanSettings.BarcodeSeparator" :label="$t('app.sform.doubledetect')"></v-switch>
              <v-select :disabled="!wsConnected || isDisbale" v-show="ScanSettings.BarcodeSeparator" :label="$t('app.sform.barcodetype')" v-model="ScanSettings.BarcodeModel" :items="barcodeItems" item-text="name"  item-value="val"></v-select>
              <v-select :disabled="!wsConnected || isDisbale" v-show="ScanSettings.BarcodeSeparator" :label="$t('app.iform.barcodedirect')" v-model="ScanSettings.BarcodeDirection" :items="barcodeDirections" item-text="name"  item-value="value"></v-select>
              <v-select :disabled="!wsConnected || isDisbale" v-show="ScanSettings.BarcodeSeparator" :label="$t('app.iform.barcodearea')" v-model="ScanSettings.BarcodeArea" :items="barcodeAreas" item-text="name"  item-value="value"></v-select>
              <v-text-field :disabled="!wsConnected || isDisbale"  v-show="ScanSettings.BarcodeSeparator" :label="$t('app.sform.regexp')" v-model="ScanSettings.BarcodeRegexp"></v-text-field>
              <v-select  :disabled="!wsConnected || isDisbale" :items="twain.Devices"  item-text="Name" item-value="Name" v-model="twain.DeviceName" @change="changeDevice" filled :label="$t('app.sform.selectdevice')" :rules="[() => !!twain.DeviceName || $t('app.sform.selectdevicerule')]" required validate-on-blur></v-select>
              <v-select :disabled="!wsConnected || isDisbale" :items="twain.Device.DPIs" v-model="ScanSettings.DPI" filled :label="$t('app.sform.dpi')" :rules="[() => !!ScanSettings.DPI || $t('app.sform.dpirule')]" required validate-on-blur></v-select>
              <v-select :disabled="!wsConnected || isDisbale" :items="twain.Device.Depths" v-model="ScanSettings.Depth" filled :label="$t('app.sform.color')" :rules="[() => !!ScanSettings.Depth || $t('app.sform.colorrule')]" required validate-on-blur></v-select>
              <v-select :disabled="!wsConnected || isDisbale" :items="twain.Device.Sizes" v-model="ScanSettings.Size" filled :label="$t('app.sform.size')" :rules="[() => !!ScanSettings.Size || $t('app.sform.sizerule')]" required validate-on-blur></v-select>
              <v-switch  v-model="ScanSettings.Duplex" :disabled="!twain.Device.CanDuplex || !wsConnected || isDisbale" :label="$t('app.sform.duplex')"></v-switch>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn :disabled="!wsConnected || isDisbale" @click="clickReloadSource" icon v-on="on"><v-icon>mdi-reload-alert</v-icon></v-btn>
                </template>
                <span>{{$t('app.sform.reload')}}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn :disabled="!twain.Device.CanSettings || !wsConnected || isDisbale" @click="clickDeviceSettings" icon v-on="on"><v-icon>mdi-cog-transfer</v-icon></v-btn>
                </template>
                <span>{{$t('app.sform.driversett')}}</span>
              </v-tooltip>
              <v-progress-circular v-show="sourceCapLoader" :size="25" :indeterminate="sourceCapLoader" color="white"></v-progress-circular>
              <br/>
              <!-- <v-alert v-show="batchUploadProfil.Quick && wsConnected && twain.DeviceName === ''" type="error" dark>
                {{$t('app.quickdevicenotfound')}}
              </v-alert> -->
            </v-col>
        </v-card>
      </v-form>
    </v-navigation-drawer>
    <v-content v-if="VIEW === 'RESGISTER_USER'">
      <User :type="VIEW_USER.type" @onCancel="changeView" @onRegisterUser="onRegisterUser" @onUpdateUser="onUpdateUser"></User>
    </v-content>
    <v-content v-if="VIEW === 'BATCH_LIST'">
      <BatchList :batches="batchItems" :ws="ws" @selectBatch="onSelectTableBatch"></BatchList>
    </v-content>
    <v-content v-if="VIEW === 'JSON_GENERATOR'">
      <JsonUrlGenerator ref="jug" @saveBatchType="saveBatchType" @saveBatchTypeExtension="saveBatchTypeExtension" @saveMobileScanSettings="saveMobileScanSettings" @changeLanguage="changeLanguage" :profil="batchUploadProfil" :mobileScanSett="mobileScanSettings" :log="log" :batchTypes="batchTypes"></JsonUrlGenerator>
    </v-content>
    <v-content id="dropfile" v-if="VIEW === 'BATCH_SCAN'">
      <v-alert style="position: fixed; z-index: 5; width: 100%;" v-model="alert" dense :color="alertColor" :icon="alertIcon" dismissible>{{alertMessage}}</v-alert>
      <v-container class="fill-width" fluid style="min-height: 434px">
        <!-- <v-fade-transition mode="out-in"> -->
          <v-expansion-panels :accordion="true" :focusable="true" :value="0">
            <v-expansion-panel>
              <v-expansion-panel-header>{{$t('singlepages')}}</v-expansion-panel-header>
              <v-expansion-panel-content id="panelSingle">
                <draggable :disabled="isDisbale || tempDisabled" :move="checkMove" @select="selectDrag" @deselect="deselectDrag" @change="onChangeDragg($event, batch.Images)" class="row" :list="batch.Images" group="files" draggable=".dragSolumaObj" animation="150" :multi-drag="true">
                  <v-col v-for="img in batch.Images" :key="img.Name" class="dragSolumaObj" :cols="thumbCols" :xs="thumbCols" :md="thumbCols" :lg="thumbCols" :xl="thumbCols" >
                    <v-card :ref="'card_' + img.Name" @click="clickFile(img)" :id="img.Name"  @dblclick="dbClickOpenInEditor(img)" @contextmenu="showContextMenu($event, img)" :outlined="img.Selected" :elevation="(img.Selected) ? 5 : 1"  :color="img.SelectedColor" :disabled="(img.ReqId > 0 || img.Exported) ? true : false" :loading="(img.Load) ? cardLoadingColor : false">
                      <div class="selecti" :style="'background-color:' + primaryColor + ' !important;'" v-show="img.Selected"></div>
                      <v-img :src="img.NoneImage ? getSvgExtAsset(img.Extension) : img.Base64" contain height="auto"></v-img>
                      <!-- <v-card-title class="title">Image</v-card-title> -->
                      <v-card-actions v-show="img.AttachmentName !== ''">
                        <span style="font-size: 11px !important; word-break: break-all;">{{ Util.truncateFileName(img.AttachmentName) }}</span>
                      </v-card-actions>
                      <div class="separator" :style="'background-color:' + primaryColor + ' !important;'" :id="img.Name + '_sep'"  @click="createSeparateDocument(img)"></div>
                    </v-card>
                    <!-- <div class="separator" :style="'background-color:' + primaryColor + ' !important;'" :id="img.Name + '_sep'"  @click="createSeparateDocument(img)"></div> -->
                    <!-- <v-divider vertical style="top:0; position: absolute;"></v-divider> -->
                  </v-col>
                </draggable>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-expansion-panels :accordion="true" :multiple="true" :focusable="true" :value="documentPanelsOpenIndicator2">
            <v-expansion-panel v-for="doc in batch.Documents" :key="doc.Id" style="margin-top: 5px;">
              <v-col @contextmenu="showContextMenu($event, doc)" @click="() => { Util.openClosePanel(documentPanelsOpenIndicator2, batch.Documents, doc) }" style="background-color: #cdcdcd; border-radius: 4px;">
              <!-- <v-expansion-panel-header :color="doc.AttachmentName !== '' ? 'yellow lighten-4' : '#e5e5e5'" @contextmenu="showContextMenu($event, doc)"> -->
                <!-- {{doc.Name + ((doc.DocClass === undefined || doc.DocClass === null ) ? '' : (doc.DocClass.Name.length === 0) ? '' : '  [' + doc.DocClass.Name + ']' )}} -->
                <!-- <v-text-field solo flat dense style="margin: 0; padding: 0; background-color: blue;" :hide-details="true"  :value="doc.Name + ((doc.DocClass === undefined || doc.DocClass === null ) ? '' : (doc.DocClass.Name.length === 0) ? '' : '  [' + doc.DocClass.Name + ']' )"></v-text-field> -->
                <DocumentTitle :ref="'docTitle' + doc.Id" :documents="batch.Documents" :indicator="documentPanelsOpenIndicator2" :doc="doc" @change="updateBatchInStorage"></DocumentTitle>
                <!-- <v-icon v-show="doc.AttachmentName !== ''" style="flex: 0 1 auto !important; padding-left: 20px;">mdi-cloud-tags</v-icon> -->
              <!-- </v-expansion-panel-header> -->
              </v-col>
              <v-expansion-panel-content>
                <draggable :disabled="isDisbale || tempDisabled" :move="checkMove" @change="onChangeDragg($event, doc)" draggable=".dragSolumaObj" class="row" :list="doc.Images" group="files" animation="150" :multi-drag="true" >
                  <v-col v-for="img in doc.Images" :key="img.Name" :cols="thumbCols" :xs="thumbCols" :md="thumbCols" :lg="thumbCols" :xl="thumbCols" class="dragSolumaObj">
                    <v-card @click="clickFile(img)" @dblclick="dbClickOpenInEditor(img)" @contextmenu="showContextMenu($event, img)" :outlined="img.Selected" :color="img.SelectedColor" :disabled="(img.ReqId > 0 || img.Exported) ? true : false" :loading="(img.Load) ? cardLoadingColor : false">
                      <div class="selecti" :style="'background-color:' + primaryColor + ' !important;'" v-show="img.Selected"></div>
                      <v-img :src="img.Base64" height="auto" class="grey darken-4"></v-img>
                      <!-- <v-card-title class="title">Image</v-card-title> -->
                    </v-card>
                  </v-col>
                </draggable>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <!-- EXTENSION PANELS FOR MOBILE SCAN -->
          <v-expansion-panels v-show="isMobileScan" :accordion="true" :multiple="true" :focusable="true" :value="false">
            <v-expansion-panel v-for="linkFolder in mobileFolders" :key="linkFolder.name">
              <v-expansion-panel-header @contextmenu="showContextMenuMobileScan($event, null, linkFolder)">{{ 'MobileScan: ' + linkFolder.Label + ' ' }}<small>{{ ' (' + linkFolder.name + ')' }}</small></v-expansion-panel-header>
              <v-expansion-panel-content>
                <draggable :disabled="isDisbale || tempDisabled" :move="checkMove" @change="onChangeDragg($event, doc)" draggable=".dragSolumaObj" class="row" :list="linkFolder.files" group="files" animation="150" :multi-drag="true" >
                  <v-col v-for="img in linkFolder.files" :key="img.Name" :cols="thumbCols" :xs="thumbCols" :md="thumbCols" :lg="thumbCols" :xl="thumbCols" class="dragSolumaObj MOBILE">
                    <v-card @click="clickFile(img)" @contextmenu="showContextMenuMobileScan($event, img, linkFolder)" :outlined="img.Selected" :color="img.SelectedColor" :disabled="(img.ReqId > 0 || img.Exported) ? true : false" :loading="(img.Load) ? cardLoadingColor : false">
                      <div class="selecti" :style="'background-color:' + primaryColor + ' !important;'" v-show="img.Selected"></div>
                      <div class="selecti" :style="'background-color: red !important; z-index: 10'" v-show="img.status === 1"></div>
                      <v-img :src="img.Base64" height="auto" class="grey darken-4"></v-img>
                      <v-card-actions v-show="img.filterId !== undefined"><span style="font-size: 11px; color: black;">{{ img.filterId }}</span></v-card-actions>
                    </v-card>
                  </v-col>
                </draggable>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        <!--</v-fade-transition>-->
      </v-container>
    </v-content>
    <v-bottom-navigation app dark height="24" :background-color="batchTypes.Current.BatchSettings.StatusBar.Color" :style="'justify-content: left; padding-left: 10px; padding-right: 10px;' + ((monday.item.id !== '') ? 'bottom: 40px;' : '')">
      <p class="systemp">{{batchTypes.Current.BatchSettings.StatusBar.Info}} <a @click="selectBatchType($event)" style="color: white; text-decoration: underline;">{{ getBatchTypeInfo }}</a></p>
      <p class="systemp" style="margin-top: 1px !important;">
        <v-badge color="red" overlap :content="totalSimFiles" :value="totalSimFiles">
          <v-btn depressed style="min-width: 45px" x-small icon @click="sim.dialog = true"><v-icon>mdi-bell</v-icon></v-btn>
        </v-badge>
      </p>
      <p v-show="monday.item.id !== ''" class="systemp" style="margin-top: 1px !important;">
        <v-badge color="red" overlap :content="monday.item.assets.filter(f => f.downloaded === false).length" :value="monday.item.assets.filter(f => f.downloaded === false).length">
          <v-btn depressed style="min-width: 45px" x-small icon @click="monday.item.dialog = true"><v-icon>$vuetify.icons.mondayicon</v-icon></v-btn>
        </v-badge>
      </p>
      <p v-show="!dataTypes.isNullOrEmpty(batchTypes.Current.EndpointMFiles.VaultId)" class="systemp" style="margin-top: 1px !important;">
        <v-badge color="red" overlap :content="mfiles.files.length" :value="mfiles.files.length">
          <v-btn :loading="mfilesDownloading" depressed style="min-width: 45px" :color="'white'" x-small icon dark @click="mfiles.dialog = true"><v-icon>$vuetify.icons.mfilesicon</v-icon></v-btn>
        </v-badge>
      </p>
      <v-spacer></v-spacer>
      <p class="systemp"><span class="systemprop">Docs:</span> {{ IndexCountDocs }}   <span class="systemprop">Pages:</span> {{ IndexCountImgs }}</p>
    </v-bottom-navigation>
    <v-menu v-model="showMenu" :position-x="x" :position-y="y" absolute offset-y>
      <v-list>
        <v-list-item v-for="(item, index) in contextMenuItems" :key="index" :disabled="item.disable === true" dis @click="clickContextItem(item)">
          <v-list-item-icon>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-dialog v-model="batchDialog" width="50%">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{$t('app.createbatch')}}
        </v-card-title>
        <v-progress-linear v-show="batchDialogLoading" :active="batchDialogLoading" :indeterminate="batchDialogLoading"></v-progress-linear>
        <v-card-text>
          <v-form ref="formBatch">
            <v-text-field clearable @focus="onFocusBatchName" @focus.native="onFocusBatchName" autofocus  v-model="batchName" :label="$t('app.cbatchname')" :rules="[() => !!batchName || $t('cbatchnamerule')]" required validate-on-blur></v-text-field>
            <v-text-field v-show="false" v-model="batchGuid" label="Id" :rules="[() => !!batchGuid || 'Please enter batch Id!']" required readonly validate-on-blur ></v-text-field>
            <v-select :label="$t('app.batchtype')" :disabled="this.batchTypes.BatchTypeJSON !== null" v-model="selectedBatchTypeId" :items="AllBatchTypes" :item-text="'Name'" :item-value="'Id'" @change="changeBatchType"></v-select>
          </v-form>
          <!-- <v-checkbox v-model="batchTypes.General.CreateBatchAuto" @change="chnageCreateBatchAuto" :label="$t('json.skipcreatebatch')"></v-checkbox> -->
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="createBatch">{{$t('app.cbatchcreate')}}</v-btn>
          <v-btn color="primary" text @click="batchDialog = false">{{$t('app.cbatchcancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="documentEditDialog" persistent width="30%">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{$t('app.editdoc')}}
        </v-card-title>
        <v-card-text>
          <v-form ref="docForm" @keydown.enter.prevent>
            <v-text-field clearable @keydown.enter="saveEditedDocument" v-model="editDoc.Name" :label="$t('app.docname')" :rules="[() => !!editDoc.Name || $t('app.docnamerule')]" required validate-on-blur></v-text-field>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="saveEditedDocument">{{$t('app.savedoc')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="batchUploadDialog" width="30%">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ !batchTypes.General.SimSettings.IsSimLite ? $t('app.upbatch') : $t('app.upbatchsimlite') }}
        </v-card-title>
        <v-card-text>
          <br/>
          {{ !batchTypes.General.SimSettings.IsSimLite ? $t('app.upconfirm', [this.batch.Name]) : $t('app.upconfirmsimlite', [this.batch.Name])}}
          <br/>
          <br/>
          <p v-show="!uploadValid.valid">
            {{$t('app.upmissingparam')}} <span class="redP" v-for="rp in uploadValid.p" :key="rp">{{rp}}</span>
          </p>
          <v-form v-show="uploadValid.valid" ref="formBatchUpload">
            <b v-if="BatchParams.length > 0">{{$t('app.reqparam')}}</b>
            <v-text-field v-for="p in BatchParams" v-show="p.visibleForm" @change="saveBatchType" :key="p.Name" clearable v-model="p.Value" :label="p.Name" :rules="[() => !!p.Value || $t('app.paramrule') + p.Name+'!']" required validate-on-blur></v-text-field>
            <b v-if="BatchProperties.length > 0">{{$t('app.batchprops')}}</b>
            <v-text-field v-for="p in BatchProperties" :key="p.Name" clearable v-model="p.Value" @change="saveBatchType" :label="p.Name" :rules="[() => !!p.Value || $t('app.paramrule') + p.Name+'!']" required validate-on-blur></v-text-field>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="!uploadValid.valid" text @click="clickUploadBatch()">{{$t('app.upupload')}}</v-btn>
          <v-btn color="primary" text @click="batchUploadDialog = false">{{$t('app.upcancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="batchUploadEndpointDialog" width="30%">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{$t('app.upbatchep')}}
        </v-card-title>
        <v-card-text>
          <br/>
          {{$t('app.upconfirmep', [this.batch.Name])}}
          <br/>
          <br/>
          <v-form ref="formBatchUploadEndpoint">
            <b v-if="BatchParams.length > 0">{{$t('app.reqparam')}}</b>
            <v-text-field v-for="p in batchUploadParams" :key="p.Name" clearable v-model="p.Value" @change="saveBatchType" :label="p.Name" :rules="[() => !!p.Value || $t('app.paramrule') + p.Name+'!']" required validate-on-blur></v-text-field>
            <v-switch v-for="p in batchUploadParamsBool" true-value="true" false-value="false" :key="p.Name" clearable v-model="p.Value" @change="saveBatchType" :label="p.Name" :rules="[() => !!p.Value || $t('app.paramrule') + p.Name+'!']" required validate-on-blur></v-switch>
            <v-text-field v-if="batchTypes.Current.EndpointSettings.Type.toUpperCase() === 'CIKOM'" v-model="documentName" clearable :label="$t('app.exportbatchendpdocname')"></v-text-field>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="clickExportBatchEndpoint">{{$t('app.upupload')}}</v-btn>
          <v-btn color="primary" text @click="batchUploadEndpointDialog = false">{{$t('app.upcancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="systemInfoDialog" width="30%">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{$t('app.sysinfo')}}
        </v-card-title>
        <v-card-text>
          <br/>
          {{systemInfoDialogMessage}}
          <br/>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" v-show="!batchTypes.Current.BatchSettings.Quick && !this.batch.Exported && systemInfoDialogAction" dark @click="clickReconnect(101)">{{ $t('app.sysinfo_reuse') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="systemProcessDialog" width="30%">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{$t('app.sysinfo')}}
        </v-card-title>
        <v-card-text>
          <br/>
          {{systemProcessDialogMessage}}
          <br/>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click="clickProcessInfo('w')">Wait</v-btn>
          <v-btn color="warning" dark @click="clickProcessInfo('k')">Kill Process</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="batchDeleteImageDialog" width="30%">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{$t('app.sysinfo')}}
        </v-card-title>
        <v-card-text>
          <br/>
          {{$t('app.deleteimagerestric', [this.selected.length, this.batch.Name])}}
          <br/>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" text @click="clickDeleteImage()">{{$t('app.ddelete')}}</v-btn>
          <v-btn color="primary" text @click="batchDeleteImageDialog = false">{{$t('app.dcancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ActivationDialog ref="activationDialog" :app="App()"></ActivationDialog>
    <v-dialog v-model="rescanDialog" persistent width="30%">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ $t('app.rescan_title') }}
        </v-card-title>
        <v-card-text>
          <v-form ref="rescanForm" @keydown.enter.prevent>
            <v-textarea v-model="rescanMessage" :label="$t('app.rescan_mess')"></v-textarea>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" text @click="rescanMobileImage(rescanMobileObj)">{{ $t('app.rescan_rescan') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="rescanDialog = false">{{ $t('app.rescan_cancle') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <BatchTypesDialog :batchTypes="batchTypes" :view="VIEW" @saveBatchType="saveBatchType"></BatchTypesDialog>
    <SimFilesDialog :sim="sim" :ws="ws" :batchTypes="batchTypes" :disabled="isDisbale || disableAction || sim.loading" @download="downloadSimFiles" @refresh="refreshSimFiles"></SimFilesDialog>
    <MFilesDialog ref="mfilesDialog" :mfiles="mfiles" :ws="ws" :disabled="isDisbale || disableAction || mfiles.loading" :app="App()"></MFilesDialog>
    <MondayFilesDialog ref="mondayFilesDialog" :monday="monday" :ws="ws" :mondayContext="mondayContext" :disabled="isDisbale || disableAction || monday.item.loading" @download="downloadMondayFiles"></MondayFilesDialog>
    <ImageEditor ref="editor" :batchTypes="batchTypes" :editdata="this.imageEditor" :rgba="batchTypes.General.rgba" @onedit="onEditImage" @loadFullSource="loadFullSourceEditor"></ImageEditor>
    <v-snackbar v-model="snackbar" :vertical="true" :timeout="snackbarTimeout">
      {{ snackbarMessage }}
      <v-btn color="indigo" text @click="snackbar = false">{{$t('app.downclose')}}</v-btn>
    </v-snackbar>
    <!-- <v-snackbar v-model="snackbarVersion" multi-line :timeout="0" top color="#fb8c00">
      {{ snackbarVersionText }}
      <v-btn dark text @click="onClickDownload" v-show="OS === 'Windows'"> {{$t('app.download')}}</v-btn>
      <v-btn dark v-show="!wsConnected && OS === 'Windows'" text @click="onClickRun"> {{$t('app.run')}}</v-btn>
      <v-btn dark text @click="snackbarVersion = false"><v-icon>mdi-close-box</v-icon></v-btn>
    </v-snackbar> -->
  </v-app>
</template>

<script>

// import Vue from 'vue'
// import StorageManager from '@/StorageManager'
// import Config from '@/Config'
import Models from '@/Models'
import Util from '@/Util'
import DataTypes from '@/DataTypes'
// import { saveAs } from 'file-saver'
import * as blobUtil from 'blob-util'
// import * as jsPDF from 'jspdf'
// import Cropper from 'cropperjs'
// import axios from 'axios'
import BatchList from '@/components/BatchList'
import User from '@/components/User'
import ImageEditor from '@/components/ImageEditor'
import DocumentTitle from '@/components/DocumentTitle'
import DateField from '@/components/DateField'
import JsonUrlGenerator from '@/components/JsonUrlGenerator'
import ActivationDialog from '@/components/ActivationDialog.vue'
import JsonURL from 'json-url'
import draggable from 'vuedraggable'
// import { MultiDrag } from 'sortablejs'
import { decompressUrlSafe } from 'lzmabase64'
// import mondaySdk from 'monday-sdk-js'
import SolumaBatchTypes, { JsonURLParser, isExportEndPoint, BatchParams, BatchProperties } from '@/SolumaBatchTypes'
import BatchTypesDialog from '@/components/BatchTypesDialog'
// import Attachments from '@/components/Attachments'
import SimFilesDialog from '@/components/SimFilesDialog'
import MFilesDialog from '@/components/MFilesDialog'
import MondayFilesDialog from '@/components/MondayFilesDialog'
import Dropzone from 'dropzone'
import Monday from './scripts/Monday'
import useMetaLicense from './MetaLicense'
import useSnackInfo from './SnackInfo'
import { format } from 'date-fns'
// import { BatchTypeModel } from '@/SolumaBatchTypes'
const SVG_XML = require('./assets/xml.svg')
const SVG_EXCEL = require('./assets/excel.svg')
const SVG_FILE = require('./assets/file.svg')
const SVG_JSON = require('./assets/json.svg')
const SVG_TXT = require('./assets/txt.svg')
const SVG_WORD = require('./assets/word.svg')
const SVG_ZIP = require('./assets/zip.svg')
const SVG_CSV = require('./assets/csv.svg')
export default {
  name: 'App',
  components: { BatchList, User, ImageEditor, JsonUrlGenerator, draggable, DateField, BatchTypesDialog, SimFilesDialog, MondayFilesDialog, MFilesDialog, DocumentTitle, ActivationDialog },
  data () {
    return {
      appInited: false,
      userGuid: '',
      documentName: '',
      documentPanelsOpenIndicator2: [],
      mfilesDownloading: false,
      isExporting: false,
      dataTypes: new DataTypes(),
      Util: Util,
      monday: {
        sdk: null,
        item: {
          id: '',
          dialog: false,
          loading: false,
          hasDownloadError: false,
          errorAsstes: [],
          assets: []
        }
      },
      dropFiles: [],
      dropFileCount: 0,
      dropFileCountLoaded: 0,
      sim: {
        SimProjects: [],
        dialog: false,
        loading: false
      },
      mfiles: {
        files: [],
        dialog: false,
        loading: false
      },
      jsonUrlData: null,
      selectedBatchTypeId: '',
      batchTypes: SolumaBatchTypes,
      rescanMobileObj: null,
      rescanMessage: '',
      rescanDialog: false,
      initedBatch: false, // after set default batch created will be true, this is related to auto created batch
      mondayContext: null,
      mobileLoading: false,
      isMonday: false,
      isIE11: false,
      isFireFox: false,
      importFolderCheckBox: false,
      isMobileScan: true,
      primaryColor: '#ffff',
      FAV_ICON: '',
      LOGO: '',
      alert: false,
      alertColor: 'red',
      alertIcon: 'mdi-alert-circle',
      alertMessage: '',
      appSettings: null,
      simSettings: null,
      mobileScanSettings: [],
      endpointSettings: null,
      autoDocClass: null,
      sourceCapLoader: false,
      illegalFileNameChars: /[<>:"/\\|?*]/g,
      dateX: 0,
      dateY: 0,
      dateDialog: false,
      dateIndexes: new Date().toISOString().substr(0, 10),
      barcodeItems: [],
      barcodeDirections: [{ name: 'All', value: 'SDTREADDIRECTION_ALL' }, { name: 'Bottom to Top', value: 'SDTREADDIRECTION_BTT' }, { name: 'Right to Left', value: 'SDTREADDIRECTION_RTL' }, { name: 'Left to Right', value: 'SDTREADDIRECTION_LTR' }, { name: 'Top to Bottom', value: 'SDTREADDIRECTION_TTB' }],
      barcodeAreas: [{ name: 'Full', value: 'FULL' }, { name: 'Top 1/3', value: 'TOP_1_3' }, { name: 'Top 1/2', value: 'TOP_1_2' }, { name: 'Bottom 1/2', value: 'BOTTOM_1_2' }, { name: 'Bottom 1/3', value: 'BOTTOM_1_3' }],
      is64Bit: false,
      VIEW: 'BATCH_SCAN',
      VIEW_USER: {
        type: 'new'
      },
      VIEW_SCAN: {
        type: ''
      },
      editDoc: {
        Name: ''
      },
      documentEditDialog: false,
      imageEditor: {
        enableEditor: false,
        batch: null,
        mobileFolder: null
      },
      log: '',
      actiovationKeyDialog: false,
      actiovationKeyLoading: false,
      softwareKey: '',
      licenseStatusCode: 1,
      IsMFilesLicense: false,
      licenseTrial: false,
      isOfflineLicense: false,
      licenseType: 'node-locked',
      licenseExpireDate: '',
      mainMenuItems: [{ title: 'mainmenu.docs', value: 'BATCH_SCAN' }, { title: 'mainmenu.batches', value: 'BATCH_LIST' }, { title: 'mainmenu.admin', value: 'JSON_GENERATOR' }, { title: 'mainmenu.license', value: 'LICENSE' }],
      // mainMenuItems: [{ title: 'BATCH SCAN', value: 'BATCH_SCAN' }, { title: 'BATCH LIST', value: 'BATCH_LIST' }, { title: 'USER SETTINGS', value: 'USER_SETTINGS' }, { title: 'REGISTER', value: 'RESGISTER_USER' }],
      autoSeparator: false,
      autoConnect: true,
      thumbCols: 1,
      tooltipVersion: false,
      snackbarVersion: false,
      snackbarVersionText: 'Download and Install new version.',
      snackbar: false,
      snackbarMessage: '',
      snackbarTimeout: 3000,
      loading: false,
      batchDialog: false,
      batchDialogLoading: false,
      batchUploadDialog: false,
      batchUploadEndpointDialog: false,
      batchDeleteImageDialog: false,
      systemProcessDialog: false,
      systemProcessDialogMessage: '',
      systemInfoDialog: false,
      systemInfoDialogMessage: '',
      systemInfoDialogAction: true,
      fileExtractDialog: false,
      fileExtractLoading: false,
      fileInputValue: null,
      fileExtractData: [],
      currentBatch: '',
      batchItems: [],
      batchGuid: '',
      batchName: '',
      ws: null,
      wsConnected: false,
      wsInterval: null,
      selected: [],
      cardLoadingColor: 'primary',
      documentCount: 0,
      mobileFolders: [],
      batch: {
        Name: '',
        Id: '',
        SessionId: '',
        Date: '',
        Path: '',
        RootPath: '',
        Documents: [],
        Images: [],
        Attachments: [],
        UploadStatus: false,
        Type: '',
        IndexCount: 0,
        IndexCountDoc: 0,
        Exported: false
      },
      requiredRequestParams: ['projectName', 'requestType', 'batchType'],
      requiredRequestParamsLite: ['type', 'user'],
      uploadValid: { valid: false, message: '', p: [] },
      batchUploadProfil: {
        Quick: false,
        SessionId: '',
        Params: [],
        BatchProperties: [],
        Classes: [],
        Indexes: [],
        Settings: [],
        ExportEndPoint: [],
        StatusBar: { Color: 'primary lighten1', Info: '' }
      },
      showMenu: false,
      x: 0,
      y: 0,
      contextMenuItems: [],
      documentIndex: {
        indexesBoard: false,
        doc: null,
        selectValues: []
      },
      twain: {
        ScanBoard: false,
        ScanBoardSettings: false,
        Devices: [],
        DeviceName: '',
        BarcodeSeparator: false,
        BarcodeRegexp: '',
        BarcodeModel: 'SDTBARCODETYPE_ALL_1D',
        BarcodeDirection: 'SDTREADDIRECTION_ALL',
        BarcodeArea: 'FULL',
        AutoSeparator: false,
        Device: {
          DPIs: [],
          Depths: [],
          Sizes: [],
          Duplex: false,
          Name: '',
          CanDuplex: false,
          CanSettings: false,
          Id: 0,
          BarcodeSeparator: false,
          AutoSeparator: false,
          BarcodeRegexp: '',
          BarcodeModel: '',
          BarcodeDirection: 'SDTREADDIRECTION_ALL',
          BarcodeArea: 'FULL',
          DPI: 300,
          Depth: 'BlackWhite',
          Size: 'A4'
        },
        Duplex: false,
        DPI: 300,
        Depth: 'BlackWhite',
        Size: 'A4'
      },
      ctrlKey: false,
      shiftKey: false,
      shiftDocId: '',
      shiftFirstIndex: 0,
      isShifted: false,
      /* disable specific action FLAG on the client side of C# process still running */
      disableAction: false
    }
  },
  computed: {
    isExportEndPoint,
    BatchProperties,
    BatchParams,
    AllowedExtensions () {
      let extensions = ''
      this.batchTypes.General.AllowedExtensions.forEach(ext => {
        extensions += (extensions === '') ? '.' + ext : ',.' + ext
      })
      return extensions
    },
    totalSimFiles () {
      let total = 0
      this.sim.SimProjects.forEach(p => {
        total += p.Files.length
      })
      return total
    },
    batchUploadParams () {
      const params = []
      this.BatchParams.forEach(p => {
        if (p.Value !== 'false' && p.Value !== 'true' && p.Value !== false && p.Value !== true) {
          params.push(p)
        }
      })
      return params
    },
    batchUploadParamsBool () {
      const params = []
      this.BatchParams.forEach(p => {
        if (p.Value === false || p.Value === true || p.Value === 'false' || p.Value === 'true') {
          params.push(p)
        }
      })
      return params
    },
    getBatchTypeInfo () {
      return '  BatchType: ' + this.batchTypes.Current.Name
    },
    AllBatchTypes () {
      const arr = []
      arr.push(...this.batchTypes.BatchTypes)
      if (this.batchTypes.BatchTypeJSON !== null) arr.push(this.batchTypes.BatchTypeJSON)
      return arr
    },
    ScanSettings () {
      console.log(this.batchTypes)
      return this.batchTypes.Current.ApplicationSettings.ScanSettings
    },
    OS () {
      const userAgent = window.navigator.userAgent
      const platform = window.navigator.platform
      const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
      const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE']
      const iosPlatforms = ['iPhone', 'iPad', 'iPod']
      let os = null
      if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS'
      } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS'
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows'
      } else if (/Android/.test(userAgent)) {
        os = 'Android'
      } else if (!os && /Linux/.test(platform)) {
        os = 'Linux'
      }
      return os
    },
    IndexCountImgs () {
      let total = 0
      total += this.batch.Images.length
      this.batch.Documents.forEach(d => {
        total += d.Images.length
      })
      return total
    },
    IndexCountDocs () {
      return this.batch.Documents.length + this.batch.Images.length
    },
    scanVisible () {
      if (this.batchTypes.Current.BatchSettings.Quick && this.batchTypes.Current.BatchSettings.Classes.length > 0) return false
      return true
    },
    importFolderExist () {
      return this.batchTypes.Current.ApplicationSettings.ImportSettings.ImportFolder.trim().length > 0
    },
    importFolderPath () {
      return this.batchTypes.Current.ApplicationSettings.ImportSettings.ImportFolder
    },
    exportFolderExist () {
      // new way
      if (this.batchTypes.Current.ApplicationSettings.ExportSettings.ExportFolder.length > 0) return true
      return false
    },
    isVisibleWithDeviceBarcode () {
      console.log('isVisibleWithDeviceBarcode', this.batchTypes.Current.BatchSettings.Quick, this.twain.Device.BarcodeSeparator)
      return this.batchTypes.Current.ApplicationSettings.ScanSettings.BarcodeSeparator
    },
    isDisbale () {
      if (this.batch.Exported || this.batch.UploadStatus) return true
      return false
    },
    documentIndexes () {
      return (this.documentIndex.doc === null) ? [] : this.documentIndex.doc.Indexes
    },
    licenseStatus () {
      return Models.LicenseStatus[this.licenseStatusCode]
    },
    tempDisabled () {
      if (this.VIEW !== Models.VIEW.BATCH_SCAN || this.isExporting || !this.wsConnected) return true
      return false
    },
    IModels () {
      return Models
    },
    disableDragg () {
      if (this.batch.Documents.length > 0) return true
      return false
    },
    documentPanelsOpenIndicator () {
      const size = this.batch.Documents.length
      const arr = []
      for (let i = 0; i < size; ++i) {
        arr.push(i)
      }
      // arr.push(size)
      // arr.push(size + 1)
      return arr
    }
  },
  methods: {
    App () {
      return this
    },
    changeSeparatorFalse (val) {
      console.log('changeSwitchFalse', val)
      window.setTimeout(() => {
        if (!this.ScanSettings.AutoSinglePageDocuments &&
        !this.ScanSettings.AutoSeparator &&
        !this.ScanSettings.FileSeparator &&
        !this.ScanSettings.BarcodeSeparator) {
          this.ScanSettings.AutoSinglePageDocuments = true
        }
        window.setTimeout(() => { useMetaLicense.checkSeparation(this.$i18n.t('licenselimitexc')) }, 100)
      }, 150)
    },
    changeSeparator (type) {
      console.log('changeSeparator', type)
      if (type === 'barcode') {
        this.ScanSettings.AutoSinglePageDocuments = false
        this.ScanSettings.AutoSeparator = false
        this.ScanSettings.FileSeparator = false
        if (!this.ScanSettings.BarcodeSeparator) {
          this.ScanSettings.AutoSinglePageDocuments = true
        }
      } else if (type === 'singlepage') {
        this.ScanSettings.BarcodeSeparator = false
        this.ScanSettings.AutoSeparator = false
        this.ScanSettings.FileSeparator = false
        if (!this.ScanSettings.AutoSinglePageDocuments) {
          this.ScanSettings.AutoSinglePageDocuments = true
        }
      } else if (type === 'circlestamp') {
        this.ScanSettings.BarcodeSeparator = false
        this.ScanSettings.AutoSinglePageDocuments = false
        this.ScanSettings.FileSeparator = false
        if (!this.ScanSettings.AutoSeparator) {
          this.ScanSettings.AutoSinglePageDocuments = true
        }
      } else if (type === 'file') {
        this.ScanSettings.BarcodeSeparator = false
        this.ScanSettings.AutoSinglePageDocuments = false
        this.ScanSettings.AutoSeparator = false
        if (!this.ScanSettings.FileSeparator) {
          this.ScanSettings.AutoSinglePageDocuments = true
        }
      }
      window.setTimeout(() => { useMetaLicense.checkSeparation(this.$i18n.t('licenselimitexc')) }, 150)
    },
    getSvgExtAsset (type) {
      if (type === undefined || type === null) type = ''
      let svgResource = SVG_FILE
      if (type.toLowerCase().indexOf('xml') > -1) svgResource = SVG_XML
      if (type.toLowerCase().indexOf('xls') > -1 || type.toLowerCase().indexOf('xlt') > -1) svgResource = SVG_EXCEL
      if (type.toLowerCase().indexOf('doc') > -1 || type.toLowerCase().indexOf('docx') > -1) svgResource = SVG_WORD
      if (type.toLowerCase().indexOf('txt') > -1) svgResource = SVG_TXT
      if (type.toLowerCase().indexOf('json') > -1) svgResource = SVG_JSON
      if (type.toLowerCase().indexOf('zip') > -1 || type.toLowerCase().indexOf('rar') > -1) svgResource = SVG_ZIP
      if (type.toLowerCase().indexOf('csv') > -1) svgResource = SVG_CSV
      return svgResource
    },
    chnageCreateBatchAuto () {
      this.saveBatchType(true)
    },
    uploadBatchSim () {
      // disable temporary 04.03.22
      /* if (this.containNoneImage(null)) {
        this.snackbar = true
        this.snackbarMessage = this.$i18n.t('restrictexportsim')
        return
      } */
      this.setValidUploadParams()
      let validValue = true
      this.BatchParams.forEach(p => {
        if (p.Value === null || p.Value.replace(/\s/g, '') === '') {
          validValue = false
          p.Value = ''
          p.visibleForm = true
        } else {
          p.visibleForm = false
        }
      })
      let requestTypeParam = this.BatchParams.find(p => p.Name === 'requestType' && p.Value.toLowerCase().trim() !== 'norcg')
      if (this.batchTypes.General.SimSettings.IsSimLite) { requestTypeParam = true }
      if (requestTypeParam) {
        if (this.containNoneImage(null)) {
          this.snackbar = true
          this.snackbarMessage = this.$i18n.t('restrictexportsim')
          return
        }
      }
      console.log('VALID VVALUE:', validValue)
      if (this.uploadValid.valid && validValue) {
        this.clickUploadBatch()
      } else {
        this.batchUploadDialog = true
        window.setTimeout(() => {
          this.$refs.formBatchUpload.validate()
        }, 500)
      }
    },
    selectBatchType (ev) {
      ev.preventDefault()
      this.batchTypes.dialog = true
    },
    changeBatchType (bTypeId) {
      console.log('Chnage batch type', bTypeId)
      this.selectedBatchTypeId = bTypeId
    },
    selectBatchTypeById () {
      if (this.batchTypes.BatchTypeJSON) return
      if (this.selectedBatchTypeId !== null && this.selectedBatchTypeId !== '') {
        const bType = this.batchTypes.BatchTypes.find(bType => bType.Id === this.selectedBatchTypeId)
        if (bType !== null && bType !== undefined) {
          this.batchTypes.BatchTypes.forEach(bt => { bt.Selected = false })
          bType.Selected = true
          console.log('selectBatchTypeById', bType)
          // this.updateSelectedBatchType(true, bType)
        }
      }
    },
    selectBatchTypeByName (name) {
      if (this.batchTypes.BatchTypeJSON) return
      if (name !== null && name !== '') {
        if (name !== this.batchTypes.Current.Name) {
          const bType = this.batchTypes.BatchTypes.find(bType => bType.Name === name)
          if (bType !== null && bType !== undefined) {
            this.batchTypes.BatchTypes.forEach(bt => { bt.Selected = false })
            bType.Selected = true
            this.updateSelectedBatchType(true, bType)
          }
        }
      }
    },
    windowResize (ev) {
      // :xs="thumbCols + 4" :md="thumbCols + 3" :lg="thumbCols + 2" :xl="thumbCols + 1"
      // console.log(this.$vuetify.breakpoint.name)
      /* switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          this.thumbCols = (this.thumbCols === 2) ? 6 : 3
          break

        case 'sm':
          this.thumbCols = (this.thumbCols === 2) ? 6 : 3
          break

        case 'md':
          this.thumbCols = (this.thumbCols === 2) ? 4 : 3
          break

        case 'lg':
          this.thumbCols = (this.thumbCols === 2) ? 3 : 2
          break

        case 'xl':
          this.thumbCols = (this.thumbCols === 2) ? 2 : 1
          break

        default:
          this.thumbCols = 1
      } */
      // console.log('THUMBS', this.thumbCols)
    },
    getIndexesRules (di) {
      if (!di.Mandatory) return []
      const iname = (di.Caption.length === 0) ? di.Name : di.Caption
      const rule = [
        v => !!v || this.$i18n.t('app.indexesRequiredRule', [iname])
      ]
      return rule
    },
    clickProcessInfo (type) {
      if (type === 'w') {
        this.systemProcessDialog = false
      }
      if (type === 'k') {
        const action = Models.Action
        action.TYPE = Models.ActionType.KILL_PROCESS
        this.ws._send(JSON.stringify(action))
      }
    },
    changeLanguage (lang) {
      console.log('chnageLanguage()', lang)
      this.$i18n.locale = lang
      window.localStorage.setItem('lang', lang)
      if (lang === 'heb') {
        this.$vuetify.rtl = true
      } else {
        this.$vuetify.rtl = false
      }
      const action = Models.Action
      action.TYPE = Models.ActionType.CHANGE_LANG
      action.Data = lang
      if (this.ws !== null) {
        console.log('change lang:' + lang)
        this.ws._send(JSON.stringify(action))
      }
    },
    setDefaultLanguage () {
      console.log('setDefaultLanguage()')
      const allLanguages = ['en', 'heb', 'hr', 'si', 'sr', 'me', 'tr']
      const queryString = window.location.search
      const urlParams = new URLSearchParams((queryString === undefined) ? '' : queryString)
      let lang = urlParams.get('lang')
      console.log('url language:' + lang)
      if (lang !== null && lang !== undefined && lang !== '') {
        if (allLanguages.indexOf(lang.toLowerCase()) < 0) lang = 'en'
      } else {
        lang = window.localStorage.getItem('lang')
        if (lang === null || lang === undefined) lang = 'en'
        if (allLanguages.indexOf(lang.toLowerCase()) < 0) lang = 'en'
        if (this.batchTypes && this.batchTypes && this.batchTypes.Current.LanguageSettings) {
          if (allLanguages.indexOf(this.batchTypes.Current.LanguageSettings.Lang) < 0) {
            lang = 'en'
          } else {
            // use json url
            lang = this.batchTypes.Current.LanguageSettings.Lang
          }
        }
      }
      this.$i18n.locale = lang
      if (lang === 'heb') {
        this.$vuetify.rtl = true
      } else {
        this.$vuetify.rtl = false
      }
      this.changeLanguage(lang)
    },
    onFocusBatchName (ev) {
      console.log(ev)
      if (ev) {
        ev.target.select()
      }
    },
    dateToString (date) {
      const year = date.getFullYear()
      const rawMonth = date.getMonth() + 1
      const mont = (rawMonth + 1 < 10) ? '0' + rawMonth : rawMonth.toString()
      const day = (date.getDate() < 10) ? '0' + date.getDate() : date.getDate().toString()
      return day + '.' + mont + '.' + year
    },
    removeDateTime (strDate) {
      let [day, moth, year] = strDate.split('.')
      year = year.substring(0, 4)
      return day + '.' + moth + '.' + year
    },
    stringToDate (strDate) {
      let [day, moth, year] = strDate.split('.')
      year = year.substring(0, 4)
      return new Date(year, moth, day)
    },
    saveDate (idc) {
      const date = new Date(idc.initialDate)
      console.log(typeof date)
      const formatDate = this.dateToString(date)
      idc.Value = formatDate
      console.log(formatDate)
      this.dateDialog = false
    },
    getBarcodeTypes () {
      return Models.BarcodeTypes
    },
    getAdjustmentStyle (img) {
      return 'top:-' + this.$refs[img.Name].style.height + 'px !important;'
    },
    saveBatchType (noInfo = true) {
      console.log('saveBatchType()')
      const action = Models.Action
      action.TYPE = Models.ActionType.SAVE_BATCH_TYPES
      action.BatchTypes = this.batchTypes
      action.NoNotification = true
      console.log('saveBatchType .. setValidUploadparam')
      this.setValidUploadParams()
      this.setForceImportScan()
      this.ws._send(JSON.stringify(action))
      this.$swsa.emitProcess(Models.ActionType.SAVE_BATCH_TYPES)
    },
    saveBatchTypeExtension (sett) {
      console.log('saveBatchTypeExtension()')
      const action = Models.Action
      action.TYPE = Models.ActionType.SAVE_BATCH_TYPES_EXTENSION
      action.Extensions = sett
      action.NoNotification = true
      this.ws._send(JSON.stringify(action))
      this.$swsa.emitProcess(Models.ActionType.SAVE_BATCH_TYPES_EXTENSION)
    },
    updateSelectedBatchType (noInfo = true, bType = null) {
      console.log('updateSelectedBatchType()', bType)
      const action = Models.Action
      action.TYPE = Models.ActionType.UPDATE_SELECTED_BATCH_TYPE
      action.BatchType = bType
      action.NoNotification = true
      this.ws._send(JSON.stringify(action))
    },
    saveAppSettings (sett) {
      console.log('saveAppSettings()', sett)
      const action = Models.Action
      action.TYPE = Models.ActionType.SAVE_APP_SETTINGS
      action.AppSettings = sett
      this.ws._send(JSON.stringify(action))
      this.$swsa.emitProcess(Models.ActionType.SAVE_APP_SETTINGS)
    },
    saveMobileScanSettings (sett) {
      console.log('saveMobileScanSettings()', sett)
      const action = Models.Action
      action.TYPE = Models.ActionType.SAVE_MOBILESCAN_SETTINGS
      action.MobileScanLinks = sett
      this.ws._send(JSON.stringify(action))
      this.$swsa.emitProcess(Models.ActionType.SAVE_MOBILESCAN_SETTINGS)
    },
    loadFullSourceEditor (img) {
      console.log('loadSourceEditor()', img)
      const action = Models.Action
      action.TYPE = Models.ActionType.LOAD_FULL_IMAGE
      action.Image = img
      this.ws._send(JSON.stringify(action))
    },
    onEditImage (opts, img, type) {
      console.log('onEditImage()', opts)
      const action = Models.Action
      action.TYPE = Models.ActionType.EDIT_IMAGE
      action.Transform = opts
      action.Image = img
      this.ws._send(JSON.stringify(action))
      this.$swsa.emitProcess(Models.ActionType.EDIT_IMAGE + (type !== null && type !== undefined) ? '_' + type : '')
    },
    getDocumentIndex (val, property) {
      for (let i = 0; i < this.batchTypes.Current.BatchSettings.Indexes.length; ++i) {
        const di = this.batchTypes.Current.BatchSettings.Indexes[i]
        if (di[property] === val) return di
      }
      return null
    },
    changeDocIndex (values) {
      console.log('changeDocIndex()', values)
      if (this.documentIndex.doc === null) return
      const indxs = this.documentIndex.doc.Indexes
      this.documentIndex.doc.Indexes.splice(0, this.documentIndex.doc.Indexes.length)
      for (let n = 0; n < values.length; ++n) {
        const di = this.getDocumentIndex(values[n], 'Name')
        if (di !== null) {
          const found = indxs.find(i => i.Name === di.Name)
          if (found) {
            this.documentIndex.doc.Indexes.push(found)
          } else {
            this.documentIndex.doc.Indexes.push(di)
          }
        }
      }
    },
    onClickDownload () {
      this.snackbarVersion = false
      window.open(window.Config.CCLIENT)
      this.$swsa.emitClick(Models.ActionType.DOWNLOAD_SETUP)
    },
    onClickRun () {
      this.snackbarVersion = false
      window.open(window.Config.PROTOCOL)
      this.$swsa.emitClick(Models.ActionType.RUN_APP)
    },
    onSelectTableBatch (ev) {
      console.log('onSelectTableBatch()', ev)
      this.currentBatch = ev.Id
      this.VIEW = Models.VIEW.BATCH_SCAN
      this.setDefaultBatch()
      this.selectBatchTypeByName(ev.Type)
    },
    changeScanType (type) {
      this.documentIndex.indexesBoard = false
      if (this.VIEW_SCAN.type === type) {
        this.twain.ScanBoard = !this.twain.ScanBoard
      } else {
        this.twain.ScanBoard = true
      }
      this.VIEW_SCAN.type = type
    },
    clickBatchExport () {
      console.log('clickBatchExport()')
      if (this.batch.Images.length === 0 && this.batch.Documents.length === 0) {
        this.snackbar = true
        this.snackbarMessage = this.$i18n.t('app.scanknofile')
        return
      }
      let mandatoryFile = null
      let illegalDoc = null
      this.batch.Images.forEach(i => {
        i.Indexes.forEach(index => {
          if (index.Mandatory && index.Value.trim() === '') {
            mandatoryFile = i
          }
        })
      })
      this.batch.Documents.forEach(d => {
        const invalid = d.Name.match(this.illegalFileNameChars)
        if (invalid !== null) {
          illegalDoc = d
        }
        d.Indexes.forEach(index => {
          if (index.Mandatory && index.Value.trim() === '') {
            mandatoryFile = d
          }
        })
      })
      if (illegalDoc !== null) {
        this.snackbar = true
        this.snackbarMessage = this.$i18n.t('app.ilegalchar', illegalDoc.Name)
        return
      }
      if (mandatoryFile !== null) {
        this.clickFile(mandatoryFile)
        this.documentIndex.indexesBoard = true
        this.twain.ScanBoard = false
        this.snackbar = true
        this.snackbarMessage = this.$i18n.t('app.exportmanrule')
        window.setTimeout(() => {
          const isValid = this.$refs.indexesForm.validate()
          console.log('Indexes Valid:', isValid)
        }, 500)
        return
      }
      const action = Models.Action
      action.TYPE = Models.ActionType.SELECT_DIR
      action.Quick = this.batchTypes.Current.BatchSettings.Quick
      action.Data = this.batchTypes.Current.ApplicationSettings.ExportSettings.ExportFolder
      this.disableAction = true
      this.ws._send(JSON.stringify(action))
      this.isExporting = true
      this.$swsa.emitClick(Models.ActionType.EXPORT_BATCH)
    },
    clickUploadBatch () {
      if (this.batch.Images.length === 0 && this.batch.Documents.length === 0) {
        this.snackbar = true
        this.snackbarMessage = this.$i18n.t('app.scanknofile')
        return
      }
      if (this.batchUploadDialog === true) {
        if (!this.$refs.formBatchUpload.validate()) return
      }
      let illegalDoc = null
      this.batch.Documents.forEach(d => {
        const invalid = d.Name.match(this.illegalFileNameChars)
        if (invalid !== null) {
          illegalDoc = d
        }
      })
      if (illegalDoc !== null) {
        this.snackbar = true
        this.snackbarMessage = this.$i18n.t('app.ilegalchar', illegalDoc.Name)
        return
      }
      const action = Models.Action
      action.TYPE = Models.ActionType.UPLOAD_BATCH
      this.ws._send(JSON.stringify(action))
      this.isExporting = true
      this.batchUploadDialog = false
      console.log('UploadParams VALID')
      this.$swsa.emitClick(Models.ActionType.UPLOAD_BATCH)
    },
    clickExportBatchEndpointPrompt () {
      this.batchUploadEndpointDialog = this.batchTypes.Current.EndpointSettings.ConfirmDialog
      if (this.batchUploadEndpointDialog === false) this.clickExportBatchEndpoint()
    },
    clickExportBatchMFiles () {
      console.log('clickExportBatchMFiles()')
      if (this.batch.Images.length === 0 && this.batch.Documents.length === 0) {
        this.snackbar = true
        this.snackbarMessage = this.$i18n.t('app.scanknofile')
        return
      }
      let mandatoryFile = null
      let illegalDoc = null
      this.batch.Images.forEach(i => {
        i.Indexes.forEach(index => {
          if (index.Mandatory && index.Value.trim() === '') {
            mandatoryFile = i
          }
        })
      })
      // check if document is classified if need clasification
      if (this.batchTypes.Current.EndpointMFiles.RequiredClassification) {
        if (this.batch.Images.length > 0) {
          this.snackbar = true
          this.snackbarMessage = this.$i18n.t('app.reqclassification')
          return
        }
        if (this.batch.Documents.length > 0) {
          for (let i = 0; i < this.batch.Documents.length; ++i) {
            const doc = this.batch.Documents[i]
            if (!doc.DocClass) {
              this.snackbar = true
              this.snackbarMessage = this.$i18n.t('app.reqclassification')
              return
            }
          }
        }
      }
      // check if document is classified if need clasification END
      this.batch.Documents.forEach(d => {
        const invalid = d.Name.match(this.illegalFileNameChars)
        if (invalid !== null) {
          illegalDoc = d
        }
        d.Indexes.forEach(index => {
          if (index.Mandatory && index.Value.trim() === '') {
            mandatoryFile = d
          }
        })
      })
      if (illegalDoc !== null) {
        this.snackbar = true
        this.snackbarMessage = this.$i18n.t('app.ilegalchar', illegalDoc.Name)
        return
      }
      if (mandatoryFile !== null) {
        this.clickFile(mandatoryFile)
        this.documentIndex.indexesBoard = true
        this.twain.ScanBoard = false
        this.snackbar = true
        this.snackbarMessage = this.$i18n.t('app.exportmanrule')
        return
      }
      const action = Models.Action
      action.TYPE = Models.ActionType.MFILES_UPLOAD
      this.disableAction = true
      this.ws._send(JSON.stringify(action))
      this.isExporting = true
      this.batchUploadEndpointDialog = false
      this.$swsa.emitClick(Models.ActionType.MFILES_UPLOAD)
    },
    clickExportBatchEndpoint () {
      console.log('clickExportBatchEndpoint()')
      if (this.batch.Images.length === 0 && this.batch.Documents.length === 0) {
        // const type = this.getUploadType()
        const type = this.batchTypes.Current.EndpointSettings.Type
        if (type === 'CIKOM' && this.batch.Attachments.length > 0) {
          // skip check
        } else {
          this.snackbar = true
          this.snackbarMessage = this.$i18n.t('app.scanknofile')
          return
        }
      }
      // check document name from CIKOM dialog if documentName is not empty rename all documents
      if (!this.dataTypes.isNullOrEmpty(this.documentName)) {
        this.batch.Documents.forEach((d, i) => {
          d.Name = this.documentName.toString() + ((i > 0) ? ' ' + i : '')
        })
        this.updateBatchInStorage()
      }

      let mandatoryFile = null
      let illegalDoc = null
      this.batch.Images.forEach(i => {
        i.Indexes.forEach(index => {
          if (index.Mandatory && index.Value.trim() === '') {
            mandatoryFile = i
          }
        })
      })
      this.batch.Documents.forEach(d => {
        const invalid = d.Name.match(this.illegalFileNameChars)
        if (invalid !== null) {
          illegalDoc = d
        }
        d.Indexes.forEach(index => {
          if (index.Mandatory && index.Value.trim() === '') {
            mandatoryFile = d
          }
        })
      })
      if (illegalDoc !== null) {
        this.snackbar = true
        this.snackbarMessage = this.$i18n.t('app.ilegalchar', illegalDoc.Name)
        return
      }
      if (mandatoryFile !== null) {
        this.clickFile(mandatoryFile)
        this.documentIndex.indexesBoard = true
        this.twain.ScanBoard = false
        this.snackbar = true
        this.snackbarMessage = this.$i18n.t('app.exportmanrule')
        return
      }
      const action = Models.Action
      action.TYPE = Models.ActionType.EXPORT_BATCH_ENDPOINT
      this.disableAction = true
      this.ws._send(JSON.stringify(action))
      this.isExporting = true
      this.batchUploadEndpointDialog = false
      this.$swsa.emitClick(Models.ActionType.EXPORT_BATCH_ENDPOINT)
      this.documentName = ''
    },
    clickExportBatchToMonday () {
      console.log('clickExportBatchToMonday()')
      if (this.batch.Images.length === 0 && this.batch.Documents.length === 0) {
        this.snackbar = true
        this.snackbarMessage = this.$i18n.t('app.scanknofile')
        return
      }
      let mandatoryFile = null
      let illegalDoc = null
      this.batch.Images.forEach(i => {
        i.Indexes.forEach(index => {
          if (index.Mandatory && index.Value.trim() === '') {
            mandatoryFile = i
          }
        })
      })
      this.batch.Documents.forEach(d => {
        const invalid = d.Name.match(this.illegalFileNameChars)
        if (invalid !== null) {
          illegalDoc = d
        }
        d.Indexes.forEach(index => {
          if (index.Mandatory && index.Value.trim() === '') {
            mandatoryFile = d
          }
        })
      })
      if (illegalDoc !== null) {
        this.snackbar = true
        this.snackbarMessage = this.$i18n.t('app.ilegalchar', illegalDoc.Name)
        return
      }
      if (mandatoryFile !== null) {
        this.clickFile(mandatoryFile)
        this.documentIndex.indexesBoard = true
        this.twain.ScanBoard = false
        this.snackbar = true
        this.snackbarMessage = this.$i18n.t('app.exportmanrule')
        window.setTimeout(() => {
          const isValid = this.$refs.indexesForm.validate()
          console.log('Indexes Valid:', isValid)
        }, 500)
        return
      }
      const action = Models.Action
      action.TYPE = Models.ActionType.UPLOAD_TO_MONDAY
      action.MondayContext = this.mondayContext
      // action.Quick = this.batchUploadProfil.Quick
      action.Quick = this.batchTypes.Current.BatchSettings.Quick
      this.disableAction = true
      this.ws._send(JSON.stringify(action))
      this.isExporting = true
      this.$swsa.emitClick(Models.ActionType.UPLOAD_TO_MONDAY)
    },
    saveEditedDocument (ev) {
      console.log('saveEditedDocument()')
      if (!this.$refs.docForm.validate()) return
      if (ev !== null) ev.preventDefault()
      this.updateBatchInStorage()
      this.documentEditDialog = false
      this.$swsa.emitProcess(Models.ActionType.EDIT_DOCUMENT)
    },
    selectDrag (ev) {
      console.log('selectDrag', ev)
    },
    deselectDrag (ev) {
      console.log('deselectDrag', ev)
    },
    checkMove (ev) {
      console.log(Array.isArray(ev.draggedContext), ev.draggedContext, ev.relatedContext)
      let draggedContext = null
      let relatedContext = null
      if (Array.isArray(ev.draggedContext)) {
        draggedContext = ev.draggedContext
      } else {
        draggedContext = [ev.draggedContext]
      }
      relatedContext = ev.relatedContext
      console.log(draggedContext, relatedContext)
      let permissibleExt = true
      if (draggedContext) {
        draggedContext.forEach(img => {
          if (img.element.NoneImage) {
            permissibleExt = false
          }
        })
      }
      // if (!permissible) return false
      if (ev.related.className.indexOf('MOBILE') > -1) return false
      if (!permissibleExt) {
        if (relatedContext && relatedContext.element.DocId !== '') {
          this.snackbar = true
          this.snackbarMessage = this.$i18n.t('restrictdoccreate')
          return false
        }
      }
      if (draggedContext) {
        draggedContext.forEach(ctx => {
          if (ctx.element.Locked) {
            return false
          }
        })
      }
      if (relatedContext && relatedContext.element && ev.relatedContext.element.Locked) return false
      return true
    },
    onChangeDragg (ev, obj) {
      console.log('onChangeDragg()', ev, obj)
      // const allImages = []
      // allImages.push(...this.batch.Images)
      if (ev.added !== undefined) {
        if (!Array.isArray(obj)) {
          if (Array.isArray(ev.added)) {
            ev.added.forEach((e) => { e.element.DocId = obj.Id })
          } else {
            ev.added.element.DocId = obj.Id
          }
        } else {
          if (Array.isArray(ev.added)) {
            ev.added.forEach((e) => { e.element.DocId = obj.Id })
          } else {
            ev.added.element.DocId = ''
          }
        }
      }
      const removeDocs = []
      for (let i = 0; i < this.batch.Documents.length; ++i) {
        const doc = this.batch.Documents[i]
        if (doc.Images.length === 0) {
          removeDocs.push(doc)
        }
      }
      removeDocs.forEach(d => this.batch.Documents.splice(this.batch.Documents.indexOf(d), 1))
      // CHECK REMOVE MOBILE SCAN FOLDER
      const removeLink = []
      for (let i = 0; i < this.mobileFolders.length; ++i) {
        const link = this.mobileFolders[i]
        if (link.files.length === 0) {
          removeLink.push(link)
        }
      }
      removeLink.forEach(l => this.mobileFolders.splice(this.mobileFolders.indexOf(l), 1))
      if (ev.removed !== null && ev.removed !== undefined) {
        console.log('REMOVED change drag')
        // this.updateBatchInStorage()
      }
      this.updateBatchInStorage()
    },
    dbClickOpenInEditor (img) {
      console.log('dbClickOpenInEditor()')
      this.clickFile(img)
      if (img.AttachmentName !== '') {
        const action = Models.Action
        action.Image = img
        action.TYPE = Models.ActionType.OPEN_FILE
        this.ws._send(JSON.stringify(action))
        return
      }
      this.imageEditor.batch = this.batch
      this.$refs.editor.image = img
      this.$refs.editor.images.splice(0, this.$refs.editor.images.length)
      if (img.IsMobile) {
        const mobFolder = this.mobileFolders.find(f => f.name === img.MobileId)
        if (mobFolder !== undefined && mobFolder !== null) {
          this.$refs.editor.title = mobFolder.name
          this.$refs.editor.images.push(...mobFolder.files)
        }
      } else {
        if (img.DocId === '' || img.DocId === undefined) {
          this.$refs.editor.title = this.$i18n.t('singlepages')
          this.$refs.editor.images.push(...this.batch.Images)
        } else {
          console.log(img.DocId)
          const doc = this.getDocumentById(img.DocId)
          console.log(doc)
          this.$refs.editor.title = doc.Name
          if (doc !== null && doc !== undefined) this.$refs.editor.images.push(...doc.Images)
        }
      }
      this.$refs.editor.enable = true
    },
    changeDevice (item) {
      console.log('changeDevice()', item)
      const device = this.twain.Devices.find(d => d.Name === item)
      console.log(device)
      const totalCap = device.DPIs.length + device.Sizes.length
      console.log('Total Cap:' + totalCap)
      if (totalCap === 0) {
        console.log('device missing capabilities! get capabilities...' + device.Name)
        this.sourceCapLoader = true
        const action = Models.Action
        action.TYPE = Models.ActionType.TWAIN_SOURCE_CAP
        action.Device = Models.Device
        action.Device.Name = device.Name
        this.ws._send(JSON.stringify(action))
      } else {
        this.setDefaultDeviceSettings(device)
      }
    },
    setDefaultDeviceSettings (device) {
      console.log('setDefaultDeviceSettings()', device)
      if (device === null || device === undefined) return
      // const twainDevice = this.twain.Device
      this.twain.Device = device
      if (this.twain.Device.DPIs.indexOf(this.batchTypes.Current.ApplicationSettings.ScanSettings.DPI) < 0) {
        if (this.twain.Device.DPIs.indexOf(300) > -1) {
          this.batchTypes.Current.ApplicationSettings.ScanSettings.DPI = 300
        } else {
          this.batchTypes.Current.ApplicationSettings.ScanSettings.DPI = this.twain.Device.DPIs[this.twain.Device.DPIs.length - 1]
        }
      }

      if (this.twain.Device.Depths.indexOf(this.batchTypes.Current.ApplicationSettings.ScanSettings.Depth) < 0) {
        if (this.twain.Device.DPIs.indexOf('BlackWhite') > -1) {
          this.batchTypes.Current.ApplicationSettings.ScanSettings.Depth = 'BlackWhite'
        } else {
          this.batchTypes.Current.ApplicationSettings.ScanSettings.Depth = this.twain.Device.Depths[this.twain.Device.Depths.length - 1]
        }
      }

      if (this.twain.Device.Sizes.indexOf(this.batchTypes.Current.ApplicationSettings.ScanSettings.Size) < 0) {
        if (this.twain.Device.Sizes.indexOf('A4') > -1) {
          this.batchTypes.Current.ApplicationSettings.ScanSettings.Size = 'A4'
        } else {
          this.batchTypes.Current.ApplicationSettings.ScanSettings.Size = this.twain.Device.Sizes[this.twain.Device.Sizes.length - 1]
        }
      }
    },
    clickDeleteImage () {
      console.log('clickDeleteImage()')
      const sortted = this.selected.sort((a, b) => (a.Index > b.Index) ? 1 : -1)
      this.processSelectedImagesForExcludeDocument(sortted)
      sortted.forEach(img => { img.DocId = '' })
      const action = Models.Action
      action.TYPE = Models.ActionType.DELETE_SCAN_IMAGE
      action.Images = this.selected
      this.ws._send(JSON.stringify(action))
      // this.updateBatchInStorage()
      this.$swsa.emitClick(Models.ActionType.DELETE_SCAN_IMAGE)
    },
    cleanDeletedImage () {
      this.unSelect(true)
      this.batchDeleteImageDialog = false
    },
    clickReconnect () {
      this.autoConnect = true
      this.openWs(101)
    },
    changeView (v) {
      console.log('changeView()', v)
      if (v.value === 'LICENSE') {
        this.actiovationKeyDialog = true
        return
      }
      this.VIEW = v.value
      if (this.VIEW === Models.VIEW.BATCH_LIST) this.getListBatches()
      if (this.VIEW === Models.VIEW.JSON_GENERATOR) {
        const action = Models.Action
        action.TYPE = Models.ActionType.LOGS
        this.ws._send(JSON.stringify(action))
      }
      this.twain.ScanBoard = false
      this.documentIndex.indexesBoard = false
      this.$swsa.emitClick(Models.ActionType.CHANGE_VIEW + '_' + this.VIEW)
    },
    onRegisterUser (v, user) {
      console.log('onRegisterUser()', user)
      const action = Models.Action
      action.User = user
      action.TYPE = Models.ActionType.INSERT_USER
      this.ws._send(JSON.stringify(action))
    },
    onUpdateUser (v, user) {
      console.log('onUpdateUser()', user)
    },
    clickMainMenu (item) {
      this.changeView(item)
    },
    clickChangeGridSize (size) {
      this.thumbCols = size
      this.windowResize()
      // console.log(this.thumbCols)
      this.$swsa.emitClick(Models.ActionType.CHANGE_GRIDSIZE)
    },
    getUID () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0; var v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    clickUploadExtract () {
      this.fileExtractDialog = true
    },
    clickCancelExtract () {
      // this.$refs.fileForm.reset()
      // console.log('clear SELCETED FILES')
      this.fileInputValue = []
      document.getElementById('fileUploaderInput').value = ''
      this.fileExtractDialog = false
      this.fileExtractData.splice(0, this.fileExtractData.length)
    },
    isFileExtensionAvaliable (file) {
      return true
      /* if (Array.isArray(file)) {
        for (let i = 0; i < file.length; ++i) {
          const fileName = file[i].name
          const ext = fileName.split('.').pop()
          if (ext.toUpperCase() !== 'TIF' && ext.toUpperCase() !== 'TIFF' && ext.toUpperCase() !== 'PDF' && ext.toUpperCase() !== 'JPG' && ext.toUpperCase() !== 'JPEG' && ext.toUpperCase() !== 'PNG' && ext.toUpperCase() !== 'BMP' && ext.toUpperCase() !== 'GIF' && ext.toUpperCase() !== 'XML') return false
          return true
        }
      } else {
        const fileName = file.name
        const ext = fileName.split('.').pop()
        if (ext.toUpperCase() !== 'TIF' && ext.toUpperCase() !== 'TIFF' && ext.toUpperCase() !== 'PDF' && ext.toUpperCase() !== 'XML') return false
        return true
      } */
    },
    changeFileSelect (file) {
      console.log('changeFileSelect()', file)
      if (file.length === 0) {
        this.fileExtractData.splice(0, this.fileExtractData.length)
        // this.fileInputValue = null
        document.getElementById('fileUploaderInput').value = ''
        if (this.batchTypes.Current.ApplicationSettings.ImportSettings.ForceImportFolder && this.importFolderExist) {
          this.importFolderCheckBox = true
        }
        return
      }
      if (!this.isFileExtensionAvaliable(file)) {
        this.snackbarMessage = this.$i18n.t('app.wrongfile')
        this.snackbar = true
        // this.$refs.fileForm.reset()
        this.fileInputValue = []
        document.getElementById('fileUploaderInput').value = ''
        return
      }
      this.importFolderCheckBox = false
      this.fileExtractLoading = 'primary'
      let counter = 1
      file.forEach(f => {
        const reader = new FileReader()
        reader.addEventListener('load', (event) => {
          console.log('load import file', event, f)
          const result = event.target.result
          if (counter === file.length) this.fileExtractLoading = false
          this.fileExtractData.push({ data: result, name: f.name })
          // console.log(result)
          counter++
        })

        reader.addEventListener('progress', (event) => {
          if (event.loaded && event.total) {
            const percent = (event.loaded / event.total) * 100
            console.log(`File Extract Progress: ${Math.round(percent)}`)
          }
        })
        reader.readAsDataURL(f)
      })
    },
    importFolder (ev, DocClass = null) {
      const action = Models.Action
      action.TYPE = Models.ActionType.IMPORT_FOLDER
      // action.ImportProfile = this.importProfile
      action.Device = this.twain.Device
      action.DocClass = this.getDefaultClass(DocClass)
      action.SessionId = this.batchTypes.Current.BatchSettings.SessionId
      action.BatchTypes = this.batchTypes
      this.ws._send(JSON.stringify(action))
      this.$swsa.emitClick(Models.ActionType.IMPORT_FOLDER)
    },
    downloadMondayFiles (ev, DocClass = null) {
      const action = Models.Action
      action.TYPE = Models.ActionType.MONDAY_FILES_DOWNLOAD
      action.Device = this.twain.Device
      action.DocClass = this.getDefaultClass(DocClass)
      action.SessionId = this.batchTypes.Current.BatchSettings.SessionId
      action.BatchTypes = this.batchTypes
      action.MondayAssets = this.monday.item.assets
      this.ws._send(JSON.stringify(action))
      this.$swsa.emitClick(Models.ActionType.MONDAY_FILES_DOWNLOAD)
    },
    downloadSimFiles (ev, DocClass = null) {
      const action = Models.Action
      action.TYPE = Models.ActionType.SIM_FILES_DOWNLOAD
      action.Device = this.twain.Device
      action.DocClass = this.getDefaultClass(DocClass)
      action.SessionId = this.batchTypes.Current.BatchSettings.SessionId
      action.BatchTypes = this.batchTypes
      action.SimProjects = this.sim.SimProjects
      this.ws._send(JSON.stringify(action))
      this.$swsa.emitClick(Models.ActionType.SIM_FILES_DOWNLOAD)
    },
    refreshSimFiles (ev) {
      const action = Models.Action
      action.TYPE = Models.ActionType.SIM_FILES
      this.ws._send(JSON.stringify(action))
      this.$swsa.emitClick(Models.ActionType.SIM_FILES)
    },
    extractFile (ev, DocClass = null) {
      console.log('extractFile()', ev)
      if (this.fileExtractData.length === 0 && this.importFolderExist) {
        this.importFolder(null, DocClass)
        return
      }
      // skip validation one form is for scan and import
      // if (!this.$refs.fileForm.validate()) return
      if (this.fileExtractData.length === 0) {
        this.snackbarMessage = this.$i18n.t('app.selecfile')
        this.snackbar = true
        return
      }
      // this.twain.ScanBoard = false
      const action = Models.Action
      action.TYPE = Models.ActionType.EXTRACT_DOCUMENT
      action.ExtractData = this.fileExtractData
      // action.ImportProfile = this.importProfile
      action.Device = this.twain.Device
      action.DocClass = this.getDefaultClass(DocClass)
      action.SessionId = this.batchTypes.Current.BatchSettings.SessionId
      action.BatchTypes = this.batchTypes
      this.ws._send(JSON.stringify(action))
      this.fileInputValue = []
      document.getElementById('fileUploaderInput').value = ''
      this.fileExtractDialog = false
      this.fileExtractData.splice(0, this.fileExtractData.length)
      this.$swsa.emitClick(Models.ActionType.EXTRACT_DOCUMENT)
    },
    processSelectedImagesForExcludeDocument (images) {
      for (let i = 0; i < images.length; ++i) {
        const imgScan = images[i]
        if (imgScan.DocId !== '') {
          const doc = this.getDocumentById(imgScan.DocId)
          if (doc !== null) {
            const imgIndex = doc.Images.indexOf(imgScan)
            if (imgIndex > -1) doc.Images.splice(imgIndex, 1)
            if (doc.Images.length === 0) {
              const indexDoc = this.batch.Documents.indexOf(doc)
              this.batch.Documents.splice(indexDoc, 1)
              // this.batch.IndexCountDoc--
            }
          }
        }
      }
      this.$swsa.emitProcess(Models.ActionType.EXCLUDE_DOCUMENT_SINGLEPAGE)
    },
    deleteDocument (doc) {
      const indexDoc = this.batch.Documents.indexOf(doc)
      this.batch.Documents.splice(indexDoc, 1)
      this.batch.IndexCountDoc--
      const images = doc.Images
      // images.forEach(img => { img.DocName = '' })
      if (images.length > 0) {
        images.forEach(img => { img.DocId = '' })
      }
      this.unSelect(false)
      this.updateBatchInStorage()
      this.$swsa.emitProcess(Models.ActionType.DELETE_DOCUMENT)
    },
    excludeDocument (doc) {
      const indexDoc = this.batch.Documents.indexOf(doc)
      this.batch.Documents.splice(indexDoc, 1)
      this.batch.IndexCountDoc--
      const images = doc.Images
      // images.forEach(img => { img.DocName = '' })
      if (images.length > 0) {
        images.forEach(img => { img.DocId = '' })
        this.batch.Images.push(...images)
        this.batch.Images.sort((a, b) => { return (a.Index > b.Index) ? 1 : -1 })
      }
      this.unSelect(false)
      this.updateBatchInStorage()
      this.$swsa.emitProcess(Models.ActionType.EXCLUDE_DOCUMENT)
    },
    unSelect (removeFromScanned = false, skipFromDoc = null) {
      for (let i = 0; i < this.selected.length; ++i) {
        const b = this.selected[i]
        b.Selected = false
        b.SelectedColor = '#fff'
        if (removeFromScanned) {
          const index = this.batch.Images.indexOf(b)
          if (index >= 0) {
            this.batch.Images.splice(index, 1)
          } else {
            for (let i = 0; i < this.batch.Documents.length; ++i) {
              const doc = this.batch.Documents[i]
              if (skipFromDoc === doc) continue
              const index = doc.Images.indexOf(b)
              if (index >= 0) doc.Images.splice(index, 1)
            }
          }
        }
      }
      this.selected.splice(0, this.selected.length)
    },
    getDocumentByName (name) {
      for (let i = 0; i < this.batch.Documents.length; ++i) {
        const doc = this.batch.Documents[i]
        if (doc.Name === name) return doc
      }
      return null
    },
    getDocumentById (id) {
      console.log('getDocumentById()', id)
      for (let i = 0; i < this.batch.Documents.length; ++i) {
        const doc = this.batch.Documents[i]
        // console.log(doc.Id)
        if (doc.Id === id) return doc
      }
      return null
    },
    getClassesContextItems () {
      const list = []
      for (let i = 0; i < this.batchTypes.Current.BatchSettings.Classes.length; ++i) {
        const c = this.batchTypes.Current.BatchSettings.Classes[i]
        list.push({ title: c.Name, type: 'select_class', icon: 'mdi-book-variant', Class: c })
      }
      return list
    },
    showContextMenu (e, img) {
      e.preventDefault()
      if (this.isDisbale) return
      // console.log('show() context menu', this.selected, img)
      this.contextMenuItems.splice(0, this.contextMenuItems.length)
      const classList = this.getClassesContextItems()
      if (img.DocId !== undefined && img.DocId !== null) {
        // if (!this.ctrlKey) { this.unSelect(false, null) }
        if (!img.Selected) {
          this.unSelect(false, null)
          img.Selected = true
          img.SelectedColor = (img.Selected) ? this.$vuetify.theme.themes.light.primary : '#ffff'
          if (img.Selected) {
            if (this.selected.indexOf(img) < 0) this.selected.push(img)
          }
        }
        if (this.selected.length === 0 || this.selected.indexOf(img) < 0) return
        if (!img.DocId) {
          this.contextMenuItems.push(...[{ title: this.$i18n.t('ctxmenu.cdoc'), type: 'create_doc', icon: 'mdi-folder-plus-outline' }, { title: this.$i18n.t('ctxmenu.deli') + '(' + this.selected.length + ')', type: 'delete_img', icon: 'mdi-delete-sweep-outline' }])
          classList.forEach(e => {
            e.Doc = img
            // e.disable = img.FileId !== ''
          })
          this.contextMenuItems.push(...classList)
        } else {
          const doc = this.getDocumentById(img.DocId)
          if (doc.Locked) {
            this.contextMenuItems.push(...[{ title: this.$i18n.t('ctxmenu.deld'), type: 'delete_doc', Doc: doc, icon: 'mdi-delete-sweep-outline' }])
          } else {
            this.contextMenuItems.push(...[{ title: this.$i18n.t('ctxmenu.cdoc'), type: 'create_doc', icon: 'mdi-folder-plus-outline' }, { title: this.$i18n.t('ctxmenu.split'), type: 'exclude_doc', Doc: doc, icon: 'mdi-folder-remove-outline' }, { title: this.$i18n.t('ctxmenu.exclude'), type: 'exclude_img', Doc: doc, Img: img, icon: 'mdi-image-remove' }, { title: this.$i18n.t('ctxmenu.deli') + '(' + this.selected.length + ')', type: 'delete_img', icon: 'mdi-delete-sweep-outline' }])
          }
        }
      } else {
        if (img.Locked) {
          this.contextMenuItems.push(...[{ title: this.$i18n.t('ctxmenu.deld'), type: 'delete_doc', Doc: img, icon: 'mdi-delete-sweep-outline' }])
        } else {
          this.contextMenuItems.push(...[{ title: this.$i18n.t('ctxmenu.edit'), type: 'edit_doc', icon: 'mdi-folder-edit-outline', Doc: img }, { title: this.$i18n.t('ctxmenu.split'), type: 'exclude_doc', Doc: img, icon: 'mdi-folder-remove-outline' }])
          classList.forEach(e => {
            e.Doc = img
            // e.disable = img.FileId !== '' // enable classification for now for all documents
          })
          this.contextMenuItems.push(...classList)
        }
      }
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    showContextMenuMobileScan (e, img, linkFolder) {
      e.preventDefault()
      if (this.isDisbale) return
      console.log('show() context menu', this.selected, img)
      this.contextMenuItems.splice(0, this.contextMenuItems.length)
      // const classList = this.getClassesContextItems()
      if (img !== undefined && img !== null) {
        // if (!this.ctrlKey) { this.unSelect(false, null) }
        if (!img.Selected) {
          this.unSelect(false, null)
          img.Selected = true
          img.SelectedColor = (img.Selected) ? this.$vuetify.theme.themes.light.primary : '#ffff'
          if (img.Selected) {
            if (this.selected.indexOf(img) < 0) this.selected.push(img)
          }
        }
        if (this.selected.length === 0 || this.selected.indexOf(img) < 0) return
        if (!img.DocId) {
          this.contextMenuItems.push(...[{ title: this.$i18n.t('ctxmenu.cdoc'), type: 'create_doc', icon: 'mdi-folder-plus-outline', Img: img, Link: linkFolder }, { title: this.$i18n.t('ctxmenu.mobilesinglepage'), type: 'add_single', icon: 'mdi-file-document-outline', Img: img, Link: linkFolder }, { title: this.$i18n.t('ctxmenu.mobilerescan'), type: 'mobile_rescan', icon: 'mdi-credit-card-scan', Img: img, Link: linkFolder }])
          // this.contextMenuItems.push(...classList)
        }
      } else {
        this.contextMenuItems.push(...[{ title: this.$i18n.t('ctxmenu.mobilerfresh'), type: 'refresh_mob_scan', icon: 'mdi-camera-flip-outline', Link: linkFolder }, { title: this.$i18n.t('ctxmenu.cdoc'), type: 'create_doc', icon: 'mdi-folder-plus-outline', Link: linkFolder }, { title: this.$i18n.t('ctxmenu.mobilesinglepages'), type: 'add_single', icon: 'mdi-file-document-outline', Link: linkFolder }])
        // this.contextMenuItems.push(...classList)
      }
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    containNoneImage (files) {
      if (files === null || files === undefined) {
        files = this.batch.Images
      }
      const found = files.find(f => f.NoneImage)
      if (found) { return true }
      return false
    },
    createDocument (item, docClass = null) {
      if (this.containNoneImage(this.selected)) {
        this.snackbar = true
        this.snackbarMessage = this.$i18n.t('restrictdoccreate')
        return
      }
      const id = Math.floor(Math.random() * 1000000)
      const doc = Models.Document
      const date = new Date()
      doc.DocClass = docClass
      // doc.Date = date.getDate() + '.' + date.getMonth() + '.' + date.getFullYear() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds()
      const formatted = format(date, 'dd.MM.yyyy HH:mm:ss')
      doc.Date = formatted
      doc.Id = id
      this.batch.IndexCountDoc++
      doc.Name = 'Document ' + this.batch.IndexCountDoc
      if (item.Link !== undefined && item.Link !== null) {
        if (item.Img === null || item.Img === undefined) {
          this.selected = []
          this.selected.push(...item.Link.files)
          item.Link.files = []
          const index = this.mobileFolders.indexOf(item.Link)
          this.mobileFolders.splice(index, 1)
        }
      }
      const selectedImages = []
      const sortted = this.selected.sort((a, b) => (a.Index > b.Index) ? 1 : -1)
      this.processSelectedImagesForExcludeDocument(sortted)
      sortted.forEach(img => { img.DocId = doc.Id })
      doc.Images.push(...sortted)
      this.unSelect(true)
      this.batch.Documents.push(doc)
      this.setIndexes(doc, this.batchTypes.Current.BatchSettings.Indexes)
      console.log(doc)
      console.log(selectedImages)
      if (item.Link !== undefined && item.Link !== null) {
        const index = item.Link.files.indexOf(item.Img)
        if (index > -1) item.Link.files.splice(index, 1)
        if (item.Link.files.length === 0) {
          const index = this.mobileFolders.indexOf(item.Link)
          this.mobileFolders.splice(index, 1)
        }
      }
      this.updateBatchInStorage()
      this.$swsa.emitProcess(Models.ActionType.CREATE_DOCUMENT)
    },
    clickContextItem (item) {
      console.log('click context', item)
      if (item.type === 'create_doc') {
        this.createDocument(item)
      } else if (item.type === 'exclude_doc') {
        this.excludeDocument(item.Doc, null)
      } else if (item.type === 'delete_doc') {
        const doc = this.getDocumentById(item.Doc.Id)
        this.deleteDocument(doc)
      } else if (item.type === 'exclude_img') {
        const sortted = this.selected.sort((a, b) => (a.Index > b.Index) ? 1 : -1)
        this.processSelectedImagesForExcludeDocument(sortted)
        sortted.forEach(img => { img.DocId = '' })
        this.batch.Images.push(...sortted)
        this.batch.Images.sort((a, b) => { return (a.Index > b.Index) ? 1 : -1 })
        this.unSelect(false)
        this.updateBatchInStorage()
      } else if (item.type === 'delete_img') {
        /* const sortted = this.selected.sort((a, b) => (a.Index > b.Index) ? 1 : -1)
        this.processSelectedImagesForExcludeDocument(sortted)
        sortted.forEach(img => { img.DocId = '' }) */
        this.batchDeleteImageDialog = true
      } else if (item.type === 'edit_doc') {
        this.editDoc = item.Doc
        this.documentEditDialog = true
      } else if (item.type === 'select_class') {
        console.log('select_class', item)
        if (item.Doc !== undefined) {
          if (item.Doc.DocId !== undefined && item.Doc.DocId !== null && item.Doc.DocId === '') {
            this.createDocument(item, item.Class)
          } else {
            item.Doc.DocClass = item.Class
            this.updateBatchInStorage()
          }
        }
      } else if (item.type === 'add_single') {
        this.addToSinglepageDocuments(item)
      } else if (item.type === 'refresh_mob_scan') {
        this.refreshMobileScanLink(item)
      } else if (item.type === 'mobile_rescan') {
        // this.rescanMobileImage(item)
        // this.unSelect(false)
        this.rescanDialog = true
        this.rescanMobileObj = item
      } else if (item.type === 'mobile_rescan_all') {
        // this.rescanMobileImage(item)
      }
    },
    rescanMobileImage (item) {
      console.log('rescanMobileImage()', item)
      this.rescanDialog = false
      const action = Models.Action
      action.TYPE = Models.ActionType.MOBILE_RESCAN
      const mobileSelected = this.selected.filter(f => f.IsMobile === true)
      mobileSelected.forEach(f => { f.comment = this.rescanMessage })
      action.Images = mobileSelected
      action.Data = this.rescanMessage
      this.mobileLoading = this.isMobileScan
      this.ws._send(JSON.stringify(action))
      this.unSelect(false)
    },
    addToSinglepageDocuments (item) {
      if (item.Img === null || item.Img === undefined) {
        this.batch.Images.push(...item.Link.files)
        item.Link.files = []
        const index = this.mobileFolders.indexOf(item.Link)
        this.mobileFolders.splice(index, 1)
      } else {
        this.batch.Images.push(item.Img)
        if (item.Link !== undefined && item.Link !== null) {
          const index = item.Link.files.indexOf(item.Img)
          if (index > -1) item.Link.files.splice(index, 1)
          if (item.Link.files.length === 0) {
            const index = this.mobileFolders.indexOf(item.Link)
            this.mobileFolders.splice(index, 1)
          }
        }
      }
      this.updateBatchInStorage()
      this.$swsa.emitProcess(Models.ActionType.ADD_TO_SINGLEPAGE_DOCS)
    },
    refreshMobileScanLink (item) {
      const action = Models.Action
      action.TYPE = Models.ActionType.MOBILE_SCAN
      action.IsMobileScan = true
      action.MobileId = item.Link.name
      this.mobileLoading = this.isMobileScan
      this.ws._send(JSON.stringify(action))
      this.$swsa.emitClick(Models.ActionType.MOBILE_SCAN)
    },
    clickFile (b) {
      console.log('clickFile()', b, b.Name)
      if (this.shiftKey) {
        if (this.selected.length === 0) {
          this.shiftDocId = b.DocId
        } else {
          if (!this.isShifted && this.selected.length > 1) {
            const last = (!this.isShifted) ? this.selected[this.selected.length - 1] : null
            this.unSelect(false, null)
            this.selected.push(last)
          }
          if (this.selected.length === 1) {
            this.shiftDocId = this.selected[0].DocId
            const images = (this.shiftDocId.length === 0) ? this.batch.Images : this.getDocumentById(this.shiftDocId).Images
            this.shiftFirstIndex = images.indexOf(this.selected[0])
          }
          if (this.shiftDocId !== b.DocId) {
            this.snackbarMessage = this.$i18n.t('app.shiftselect')
            this.snackbar = true
            return
          }
        }
        // if (b.selected && this.selected.indexOf(b) === 0) return
        const images = (this.shiftDocId === '') ? this.batch.Images : this.getDocumentById(this.shiftDocId).Images
        const index = images.indexOf(b)
        if (this.selected.length === 0) {
          this.shiftFirstIndex = images.indexOf(b)
          b.Selected = !b.Selected
          b.SelectedColor = (b.Selected) ? this.$vuetify.theme.themes.light.primary : '#ffff'
          // this.readFile(b)
          if (b.Selected) {
            if (this.selected.indexOf(b) < 0) this.selected.push(b)
          } else {
            const index = this.selected.indexOf(b)
            if (index > -1) this.selected.splice(index, 1)
          }
        } else {
          if (index !== this.shiftFirstIndex) {
            const sIndex = (this.shiftFirstIndex < index) ? this.shiftFirstIndex : index
            const eIndex = (this.shiftFirstIndex < index) ? index : this.shiftFirstIndex
            const selectionImages = images.filter((e, i) => { return i >= sIndex && i <= eIndex })
            this.unSelect(false, null)
            for (let i = 0; i < selectionImages.length; ++i) {
              const fi = selectionImages[i]
              fi.Selected = !fi.Selected
              fi.SelectedColor = (fi.Selected) ? 'primary' : '#ffff'
              if (fi.Selected) {
                if (this.selected.indexOf(fi) < 0) this.selected.push(fi)
              }
            }
          }
        }
        return
      }
      if (!this.ctrlKey) { this.unSelect(false, null) }
      b.Selected = !b.Selected
      b.SelectedColor = (b.Selected) ? this.$vuetify.theme.themes.light.primary : '#ffff'
      // this.readFile(b)
      if (b.Selected) {
        if (this.selected.indexOf(b) < 0) this.selected.push(b)
        let doc = this.getDocumentById(b.DocId)
        if (doc === null) doc = b
        this.documentIndex.doc = doc
      } else {
        const index = this.selected.indexOf(b)
        if (index > -1) this.selected.splice(index, 1)
      }
    },
    convertDataURIToBinary (dataURI) {
      var BASE64_MARKER = ';base64,'
      var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length
      var base64 = dataURI.substring(base64Index)
      var raw = window.atob(base64)
      const rawLength = raw.length
      var array = new Uint8Array(new ArrayBuffer(rawLength))
      for (let i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i)
      }
      return array
    },
    async readFile (f) {
      await blobUtil.imgSrcToBlob(f.file, 'image/png', '', 1).then(function (blob) {
        console.log('Blobl fetch')
        console.log(blob)
        // blob.size = b.size
        // saveAs(new File([blob], 'test'), 'test.png')
        return blob
      }).catch(function (err) {
        console.log(err)
        return null
      })
    },
    clickDeviceSettings () {
      console.log('clickDeviceSettings()', this.twain.Device)
      // if (!this.$refs.scanForm.validate()) return
      const action = Models.Action
      action.TYPE = Models.ActionType.DRIVER_SETTINGS
      const device = Models.Device
      device.Name = this.twain.Device.Name
      action.Device = device
      this.ws._send(JSON.stringify(action))
      this.$swsa.emitClick(Models.ActionType.DRIVER_SETTINGS)
    },
    changeImportFolderCheckBox (val) {
      if (val === true) {
        this.fileInputValue = []
        this.fileExtractData = []
        document.getElementById('fileUploaderInput').value = ''
      }
    },
    getDefaultClass (DocClass) {
      if (DocClass === null || DocClass === undefined) {
        const dc = this.batchTypes.Current.BatchSettings.Classes.find(dc => dc.Default === true)
        if (dc !== undefined && dc !== null) { DocClass = dc }
      }
      return DocClass
    },
    clickQuickScanBoard (ev, DocClass) {
      console.log('clickQuickScanBoard', ev, DocClass, this.importFolderExist, this.importFolderCheckBox, this.fileExtractData, this.batchTypes.Current.BatchSettings.Classes)
      DocClass = this.getDefaultClass(DocClass)
      if (!this.importFolderExist && this.fileExtractData.length === 0) {
        this.clickScanBoard(ev, DocClass)
        return
      }
      if (this.importFolderCheckBox && this.importFolderExist) {
        this.importFolder(ev, DocClass)
      } else if (this.fileExtractData.length > 0) {
        this.extractFile(ev, DocClass)
      } else {
        this.clickScanBoard(ev, DocClass)
      }
    },
    clickScanBoard (ev, DocClass) {
      console.log('clickScanBoard()', this.twain.Device, this.$refs.scanForm.validate())
      if (!this.$refs.scanForm.validate()) {
        this.twain.ScanBoardSettings = true
        return
      }
      DocClass = this.getDefaultClass(DocClass)
      // this.twain.ScanBoard = false
      const action = Models.Action
      action.TYPE = Models.ActionType.SCAN
      action.DocClass = DocClass
      action.BatchTypes = this.batchTypes
      action.SessionId = this.batchTypes.Current.BatchSettings.SessionId
      action.Device = this.twain.Device
      this.ws._send(JSON.stringify(action))
      this.$swsa.emitClick(Models.ActionType.SCAN)
    },
    clickReloadSource () {
      console.log('clickReloadSource()')
      const action = Models.Action
      action.TYPE = Models.ActionType.TWAIN_SOURCE_RELOAD
      this.sourceCapLoader = true
      this.ws._send(JSON.stringify(action))
      this.$swsa.emitClick(Models.ActionType.TWAIN_SOURCE_RELOAD)
      this.$swsa.emitClick(Models.ActionType.TWAIN_SOURCE_RELOAD)
    },
    clickScan (ev) {
      console.log('clickScan()', ev)
      this.twain.ScanBoard = !this.twain.ScanBoard
    },
    clickCreateBatch (ev, auto = false) {
      console.log('clickCreateBatch()', ev)
      this.selectedBatchTypeId = this.batchTypes.Current.Id
      this.batchGuid = this.getUID()
      const date = new Date()
      const year = date.getFullYear()
      const rawMonth = date.getMonth() + 1
      const mont = (rawMonth < 10) ? '0' + rawMonth : rawMonth.toString()
      const day = (date.getDate() < 10) ? '0' + date.getDate() : date.getDate().toString()
      const h = (date.getHours() < 10) ? '0' + date.getHours() : date.getHours().toString()
      const m = (date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes().toString()
      const s = (date.getSeconds() < 10) ? '0' + date.getSeconds() : date.getSeconds().toString()
      this.batchName = 'Batch ' + day + '_' + mont + '_' + year + ' ' + h + '_' + m + '_' + s
      if (!auto) this.batchDialog = true
      if (this.VIEW !== Models.VIEW.BATCH_SCAN) {
        this.VIEW = Models.VIEW.BATCH_SCAN
      }
    },
    createBatch (ev, auto = false, NoNotification = false) {
      console.log('createBatch()', ev, (!auto) ? this.$refs.formBatch.validate() : 'no validation need')
      if (!auto) {
        if (!this.$refs.formBatch.validate()) return
      } else {
        this.clickCreateBatch(null, auto)
      }
      this.selectBatchTypeById()
      const batch = Models.Batch
      batch.Name = this.batchName
      batch.Id = this.batchGuid
      batch.SessionId = this.batchTypes.Current.BatchSettings.SessionId
      const action = Models.Action
      action.TYPE = Models.ActionType.CREATE_BATCH
      action.BatchType = this.batchTypes.Current
      action.BatchTypes = this.batchTypes
      action.Batch = batch
      action.NoNotification = NoNotification
      this.batchDialogLoading = true
      this.ws._send(JSON.stringify(action))
      /* if (this.VIEW !== Models.VIEW.BATCH_SCAN) {
        this.VIEW = Models.VIEW.BATCH_SCAN
      } */
      this.$swsa.emitClick(Models.ActionType.CREATE_BATCH)
    },
    getAppSettings () {
      console.log('getAppSettings()')
      const action = Models.Action
      action.TYPE = Models.ActionType.LOAD_APP_SETTINGS
      this.ws._send(JSON.stringify(action))
    },
    getLicense () {
      console.log('getLicense()')
      const action = Models.Action
      action.TYPE = Models.ActionType.LICENSE
      action.EndpointMFiles = (!this.dataTypes.isNullOrEmpty(this.batchTypes.Current.EndpointMFiles.VaultId)) ? this.batchTypes.Current.EndpointMFiles : null
      this.ws._send(JSON.stringify(action))
    },
    getVersion () {
      console.log('getVersion()')
      const action = Models.Action
      action.TYPE = Models.ActionType.VERSION
      this.ws._send(JSON.stringify(action))
    },
    getDefaultBatch () {
      console.log('getDefaultBatch()')
      const action = Models.Action
      action.TYPE = Models.ActionType.DEFAULT_BATCH
      /* old batch type
      action.UploadProfil = this.batchUploadProfil */
      this.ws._send(JSON.stringify(action))
    },
    setDefaultBatch () {
      console.log('setDefaultBatch()')
      const action = Models.Action
      action.TYPE = Models.ActionType.SET_DEFAULT_BATCH
      const b = Models.Batch
      b.Id = this.currentBatch
      action.Batch = b
      this.ws._send(JSON.stringify(action))
    },
    loadMobileScan (auto = true) {
      console.log('loadMobileScan()', this.mobileScanSettings.length)
      if (this.mobileScanSettings.length === 0) return
      if (!auto) this.isMobileScan = !this.isMobileScan
      const action = Models.Action
      action.TYPE = Models.ActionType.MOBILE_SCAN
      action.IsMobileScan = this.isMobileScan
      this.mobileLoading = this.isMobileScan
      console.log('Mobile Loading', this.mobileLoading)
      this.ws._send(JSON.stringify(action))
    },
    getListBatches () {
      console.log('getListBatches()')
      const action = Models.Action
      action.TYPE = Models.ActionType.LIST_BATCHES
      this.ws._send(JSON.stringify(action))
    },
    getSimFiles () {
      console.log('getSimFiles()')
      const action = Models.Action
      action.TYPE = Models.ActionType.SIM_FILES
      this.ws._send(JSON.stringify(action))
    },
    getMFiles () {
      console.log('getMFiles()', this.batchTypes.Current.EndpointMFiles)
      if (!this.dataTypes.isNullOrEmpty(this.batchTypes.Current.EndpointMFiles.VaultId)) {
        // this.saveBatchType()
        console.log('refresh MFILES')
        this.$refs.mfilesDialog.refresh(null, true)
      }
    },
    getTwainSourceDevices () {
      console.log('getTwainSourceDevices()')
      const action = Models.Action
      action.TYPE = Models.ActionType.TWAIN_SOURCE_LIST
      this.ws._send(JSON.stringify(action))
    },
    createSeparateDocument (imgScan) {
      if (this.isDisbale || this.tempDisabled || this.disableAction) return
      const id = Math.floor(Math.random() * 1000000)
      const index = this.batch.Images.indexOf(imgScan)
      if (this.containNoneImage(this.batch.Images.slice().splice(0, index + 1))) {
        this.snackbar = true
        this.snackbarMessage = this.$i18n.t('restrictdoccreate')
        return
      }
      const selectedImages = this.batch.Images.splice(0, index + 1)
      const doc = Models.Document
      this.batch.IndexCountDoc++
      doc.Id = id
      doc.Name = 'Document ' + this.batch.IndexCountDoc
      selectedImages.forEach(img => { img.DocId = doc.Id })
      doc.Images.push(...selectedImages)
      this.batch.Documents.push(doc)
      this.updateBatchInStorage()
      this.$swsa.emitClick(Models.ActionType.CREATE_DOCUMENT_SEPARATOR)
    },
    updateBatchInStorage () {
      if (this.isDisbale) return
      console.log('updateBatchInStorage()', this.batch)
      const action = Models.Action
      this.batch.IndexCount = this.batch.Images.length
      this.batch.IndexCountDoc = this.batch.Documents.length
      this.batch.Documents.forEach(d => {
        this.batch.IndexCount += d.Images.length
      })
      action.TYPE = Models.ActionType.UPDATE_BATCH
      action.Batch = this.batch
      this.ws._send(JSON.stringify(action))
    },
    async updateLimit () {
      const action = Models.Action
      action.TYPE = Models.ActionType.LIMIT
      this.ws._send(JSON.stringify(action))
    },
    addImageScanInDocument (imgScan) {
      console.log('addImageScanInDocument()', this.batch.Documents)
      // const doc = this.batch.Documents.find(d => d.Name === imgScan.DocName)
      const doc = this.batch.Documents.find(d => d.Id.toString() === imgScan.DocId.toString())
      if (doc !== null && doc !== undefined) doc.Images.push(imgScan)
    },
    setBatch (b) {
      if (b === null) return
      console.log('setBatch()')
      this.batch.Images.splice(0, this.batch.Images.length)
      this.batch.Documents.splice(0, this.batch.Documents.length)
      this.batch.Attachments.splice(0, this.batch.Attachments.length)
      this.batch.Images.push(...b.Images)
      this.batch.Documents.push(...b.Documents)
      this.batch.Attachments.push(...b.Attachments)
      this.batch.Images.forEach((bi) => {
        if (bi.Selected) {
          bi.Selected = false
          bi.SelectedColor = '#fff'
        }
      })
      this.batch.Documents.forEach((d) => {
        d.Images.forEach((di) => {
          if (di.Selected) {
            di.Selected = false
            di.SelectedColor = '#fff'
          }
        })
      })
      this.batch.Path = b.Path
      this.batch.Name = b.Name
      this.batch.Date = b.Date
      this.batch.Id = b.Id
      this.batch.SessionId = (b.SessionId === undefined) ? '' : b.SessionId
      this.batch.IndexCountDoc = b.IndexCountDoc
      this.batch.IndexCount = b.IndexCount
      // eslint-disable-next-line no-unneeded-ternary
      this.batch.UploadStatus = (b.UploadStatus === undefined) ? false : b.UploadStatus
      this.batch.Type = b.Type
      this.batch.RootPath = b.RootPath
      this.batch.Exported = b.Exported
      this.currentBatch = this.batch.Id
      this.batch.Images.forEach(e => this.setIndexes(e, this.batchTypes.Current.BatchSettings.Indexes))
      this.batch.Documents.forEach(d => this.setIndexes(d, this.batchTypes.Current.BatchSettings.Indexes))
      this.unSelect(false)
    },
    cleanBatch () {
      console.log('cleanBatch()')
      this.batch.Images.splice(0, this.batch.Images.length)
      this.batch.Documents.splice(0, this.batch.Documents.length)
      this.batch.Path = ''
      this.batch.Name = ''
      this.batch.Id = ''
      this.batch.IndexCountDoc = 0
      this.batch.IndexCount = 0
      // eslint-disable-next-line no-unneeded-ternary
      this.batch.UploadStatus = true
      this.batch.Exported = true
      this.batch.Type = ''
      this.batch.RootPath = ''
      this.currentBatch = ''
    },
    setDocumentProgress (progress) {
      const doc = this.batch.Documents.find(d => d.Name === progress.Document.Name)
      if (doc !== null && doc !== undefined) {
        const prog = progress.Progress
        doc.Images.forEach(img => {
          img.Load = (prog < 100)
          img.ReqId = progress.Document.ReqId
          img.Exported = progress.Document.Exported
        })
      }
      console.log(doc)
    },
    setImageProgress (progress) {
      const imgScan = this.batch.Images.find(img => img.Name === progress.Image.Name)
      if (imgScan !== null && imgScan !== undefined) {
        const prog = progress.Progress
        imgScan.Load = (prog < 100)
        imgScan.ReqId = progress.Image.ReqId
        imgScan.Exported = progress.Image.Exported
      }
      console.log(imgScan)
    },
    cancelProgress () {
      this.batch.Images.forEach(imgScan => {
        imgScan.Load = false
        imgScan.ReqId = -1
        imgScan.Exported = false
      })
      this.batch.Documents.forEach(d => {
        d.Exported = false
        d.Images.forEach(imgScan => {
          imgScan.Load = false
          imgScan.ReqId = -1
          imgScan.Exported = false
        })
      })
    },
    compareVersions (v1, comparator, v2) {
      comparator = comparator === '=' ? '==' : comparator
      if (['==', '===', '<', '<=', '>', '>=', '!=', '!=='].indexOf(comparator) === -1) {
        throw new Error('Invalid comparator. ' + comparator)
      }
      console.log('Check Version', v1, v2)
      var v1parts = v1.split('.')
      var v2parts = v2.split('.')
      var maxLen = Math.max(v1parts.length, v2parts.length)
      var part1, part2
      var cmp = 0
      for (var i = 0; i < maxLen && !cmp; i++) {
        part1 = parseInt(v1parts[i], 10) || 0
        part2 = parseInt(v2parts[i], 10) || 0
        if (part1 < part2) { cmp = 1 }
        if (part1 > part2) { cmp = -1 }
      }
      // eslint-disable-next-line no-eval
      // console.log('version indicator', cmp)
      // return eval('0' + comparator + cmp)
      console.log('Version Comp', cmp)
      return cmp
    },
    getSystemEnvProcess () {
      const action = Models.Action
      action.TYPE = Models.ActionType.SYSTEM_ENV_PROCESS
      this.ws._send(JSON.stringify(action))
    },
    sendAction (action) {
      // console.log('sendAction', action)
      this.alert = false
      this.ws.send(action)
    },
    removeMarkedImages (list) {
      const docs = []
      list.forEach(i => {
        const isc = this.batch.Images.find(img => i.Name === img.Name)
        if (isc !== null && isc !== undefined) {
          const index = this.batch.Images.indexOf(isc)
          this.batch.Images.splice(index, 1)
          console.log('remove IMAGE', isc)
        } else {
          this.batch.Documents.forEach(d => {
            const iscd = d.Images.find(img => i.Name === img.Name)
            if (iscd !== null && iscd !== undefined) {
              const index = d.Images.indexOf(iscd)
              d.Images.splice(index, 1)
              if (d.Images.length === 0) docs.push(d)
            }
          })
        }
      })
      docs.forEach(d => {
        const index = this.batch.Documents.indexOf(d)
        this.batch.Documents.splice(index, 1)
      })
    },
    setForceImportScan () {
      if (this.batchTypes.Current.ApplicationSettings.ImportSettings.ForceImportFolder === true && this.importFolderExist) {
        this.importFolderCheckBox = true
      } else {
        this.importFolderCheckBox = false
      }
    },
    openWs (status = 0) {
      if (this.wsConnected === true) return
      console.log('opneWs()')
      if (this.ws !== null) {
        this.ws.onopen = null
        this.ws.onerror = null
        this.ws.onclose = null
        this.ws.onmessage = null
        this.ws._send = null
      }
      this.systemInfoDialog = false
      this.systemInfoDialogMessage = ''
      this.ws = null
      this.ws = new WebSocket('wss://localhost:' + window.Config.PORT + `/?principal=${this.userGuid}&status=${status}`)
      this.ws._send = this.sendAction
      // const _this = this
      this.ws.onopen = (ev) => {
        this.wsConnected = true
        console.log('WebSocket connected:', ev)
        this.getLicense()
        /* this.getVersion()
        this.getSystemEnvProcess()
        this.getAppSettings()
        if (this.batchTypes.Current.EndpointMFiles.AutoNewBatch && !this.appInited) {
          this.createBatch(null, true)
        }
        this.getDefaultBatch()
        this.getListBatches()
        this.getTwainSourceDevices()
        this.getSimFiles()
        this.getMFiles() */
        /* window.setTimeout(() => {
          this.appInited = true
          this.getMFiles()
        }, 2000) */
      }
      this.ws.onerror = this.onError
      this.ws.onclose = this.onClose
      this.ws.onmessage = this.onMessage
      this.isExporting = false
    },
    onClose (ev) {
      console.log('OnClose WebSocket:', ev)
      this.isExporting = false
      this.wsConnected = false
      this.snackbarMessage = this.$i18n.t('app.connclosed')
      this.snackbar = true
      const _this = this
      if (!this.autoConnect) return
      window.setTimeout(function () {
        if (!_this.wsConnected) {
          _this.snackbarMessage = _this.$i18n.t('app.connre')
          _this.snackbar = true
          _this.openWs()
        }
      }, 6000)
    },
    onError (ev) {
      console.log('OnError WebSocket:', ev)
      if (ev.target.readyState === 3) {
        if (this.OS === 'Windows') {
          this.snackbarVersionText = this.$i18n.t('app.connerinfo')
          this.snackbarVersion = true
        } else {
          this.snackbarVersionText = this.$i18n.t('app.osInfo')
          this.snackbarVersion = true
        }
      }
      this.ws.close()
    },
    changeIndexesValue (ev) {
      console.log('changeIndexesValue()', ev)
      this.updateBatchInStorage()
    },
    setIndexes (doc, indices) {
      console.log('setIndices()', doc, indices)
      if (indices.length === 0) {
        doc.Indexes.splice(0, doc.Indexes.length)
        return
      }
      const copyIndices = Models.copyIndexes(indices)
      for (let i = 0; i < copyIndices.length; ++i) {
        const idc = copyIndices[i]
        if (idc.CurrentDate && idc.Value.trim() === '') idc.Value = this.removeDateTime(doc.Date)
        idc.initialDate = new Date().toISOString().substr(0, 10)
        const found = doc.Indexes.find(e => e.Name === idc.Name)
        if (found !== null && found !== undefined) {
          found.DataType = idc.DataType
          found.Caption = idc.Caption
          found.CurrentDate = idc.CurrentDate
          found.Mandatory = idc.Mandatory
          found.initialDate = new Date().toISOString().substr(0, 10)
        }
        // console.log(found)
        if (found === null || found === undefined) doc.Indexes.push(idc)
      }
    },
    setFavIcon (data) {
      var nodeList = document.getElementsByTagName('link')
      for (var i = 0; i < nodeList.length; i++) {
        if ((nodeList[i].getAttribute('rel') === 'icon') || (nodeList[i].getAttribute('rel') === 'shortcut icon')) {
          nodeList[i].setAttribute('href', data)
        }
      }
    },
    onMessage (ev) {
      // console.log('OnMessage WebSocket:', ev)
      const data = JSON.parse(ev.data, function (key, value) {
        return value
      })
      // console.log(data)

      if (data.TYPE === Models.ActionType.PROCESS_INFO) {
        if (data.StatusCode === 500) {
          this.systemProcessDialogMessage = data.StatusMessage
          this.systemProcessDialog = true
        }
      }

      if (data.TYPE === Models.ActionType.SELECT_DIR) {
        if (data.StatusCode === 200) {
          this.batchTypes.Current.ApplicationSettings.ExportSettings.ExportFolder = data.Data
        }
      }

      if (data.TYPE === Models.ActionType.LOAD_APP_SETTINGS) {
        if (data.StatusCode === 500) {
          this.systemProcessDialogMessage = data.StatusMessage
          this.systemProcessDialog = true
        } else {
          useMetaLicense.parse(data.MetaLicense)
          this.batchTypes.BatchTypes = data.BatchTypes.BatchTypes
          // check ForceImportFolder
          this.setForceImportScan()
          this.batchTypes.APP_FOLDER = data.BatchTypes.APP_FOLDER
          this.batchTypes.FILE_NAME = data.BatchTypes.FILE_NAME
          this.batchTypes.General = data.BatchTypes.General
          if (this.batchTypes.BatchTypeJSON !== null) {
            this.selectedBatchTypeId = this.batchTypes.BatchTypeJSON.Id
            // this.batchTypes.BatchTypes.forEach(bType => { bType.Selected = false })
            window.setTimeout(() => { this.saveBatchType() }, 300)
          } else {
            this.selectedBatchTypeId = this.batchTypes.Current.Id
          }
          this.mobileScanSettings = data.MobileScanLinks
          this.isMobileScan = data.IsMobileScan
          // this.setUploadParams()
          this.setValidUploadParams()
          if (this.isMobileScan) this.loadMobileScan()
          useMetaLicense.checkSeparation(this.$i18n.t('licenselimitexc'), false)
        }
      }

      if (data.TYPE === Models.ActionType.KILL_PROCESS) {
        this.systemProcessDialog = false
        this.systemProcessDialogMessage = ''
        this.snackbar = true
        this.snackbarMessage = data.StatusMessage
      }

      if (data.TYPE === Models.ActionType.DEACTIVATION) {
        this.actiovationKeyLoading = false
        if (data.StatusCode === 200) {
          this.licenseStatusCode = data.LicenseStatus
          this.licenseExpireDate = ''
          this.licenseType = data.LicenseType
          this.softwareKey = ''
        } else if (data.StatusCode === 103) {
          this.softwareKey = data.Data
          this.$refs.activationDialog.deactivateKey = data.Data
          this.$refs.activationDialog.offlineDeactivationRequest = true
          this.$refs.activationDialog.offlineRequestDeactivationData = data.OfflineRequestDeactivationData
        } else {
          this.snackbarMessage = data.StatusMessage
          this.snackbar = true
        }
      }

      if (data.TYPE === Models.ActionType.LICENSE) {
        console.log('onLIcense:' + Models.ActionType.LICENSE, data)
        if (data.StatusCode === 200) {
          this.MFilesLicenseStatus = data.MFilesLicenseStatus
          this.IsMFilesLicense = data.IsMFilesLicense
          this.licenseStatusCode = data.LicenseStatus
          this.licenseTrial = data.IsTrialLicense
          this.isOfflineLicense = data.IsOfflineLicense
          this.licenseType = data.LicenseType
          this.licenseExpireDate = data.LicenseExpireDate
          this.softwareKey = data.Data
          this.LOGO = data.Logo
          this.setFavIcon(data.Icon)
          this.setDefaultLanguage()
          // setup analytics
          if (data.DeviceId !== undefined && data.DeviceId !== '') {
            this.$swsa.enableEmit(true)
            this.$swsa.setTrial(this.licenseTrial)
            const key = (this.licenseTrial) ? 'TRIAL' : this.softwareKey
            this.$swsa.setLicense(key)
            this.$swsa.setLicenseStatus(this.licenseStatusCode)
            this.$swsa.setLicenseId(data.LicenseId)
            this.$swsa.setDeviceId(data.DeviceId)
            this.$swsa.setMachineUserName(data.MachineUserName)
            this.$swsa.setMachineName(data.MachineName)
            this.$swsa.setVersion(data.Version)
            this.$swsa.setPublisher(data.Publisher)
          }
          this.getVersion()
          this.getSystemEnvProcess()
          this.getAppSettings()
          if (this.batchTypes.Current.EndpointMFiles.AutoNewBatch && !this.appInited) {
            this.createBatch(null, true, true)
          }
          this.getDefaultBatch()
          
          
          if (!this.appInited) {
            this.getSimFiles()
            this.getMFiles()
            this.appInited = true
          }
          // this.getListBatches()
          this.getTwainSourceDevices()
        } else {
          this.snackbarMessage = data.StatusMessage
          this.snackbar = true
        }
      }

      if (data.TYPE === Models.ActionType.ACTIVATION) {
        this.actiovationKeyLoading = false
        console.log(Models.ActionType.ACTIVATION, data)
        if (data.StatusCode === 200) {
          this.licenseStatusCode = data.LicenseStatus
          this.licenseExpireDate = data.LicenseExpireDate
          this.softwareKey = data.Data
          this.licenseTrial = data.IsTrialLicense
          if (data.LicenseStatus !== 0) {
            this.actiovationKeyDialog = true
          } else if (data.LicenseStatus === 0) {
            this.$refs.activationDialog.offlineRequest = false
            this.$refs.activationDialog.offlineRequestData = ''
            this.actiovationKeyDialog = false
            this.isOfflineLicense = data.IsOfflineLicense
            this.licenseType = data.LicenseType
            // setup analytics
            if (data.DeviceId !== undefined && data.DeviceId !== '') {
              this.$swsa.enableEmit(true)
              this.$swsa.setTrial(this.licenseTrial)
              const key = (this.licenseTrial) ? 'TRIAL' : this.softwareKey
              this.$swsa.setLicense(key)
              this.$swsa.setLicenseStatus(this.licenseStatusCode)
              this.$swsa.setLicenseId(data.LicenseId)
              this.$swsa.setDeviceId(data.DeviceId)
              this.$swsa.setMachineUserName(data.MachineUserName)
              this.$swsa.setMachineName(data.MachineName)
              this.$swsa.setVersion(data.Version)
              this.$swsa.setPublisher(data.Publisher)
            }
            this.getVersion()
            this.getSystemEnvProcess()
            this.getAppSettings()
            this.getDefaultBatch()
            this.getListBatches()
            this.getTwainSourceDevices()
            this.getSimFiles()
            this.getMFiles()
          }
        } else if (data.StatusCode === 103) {
          this.softwareKey = data.Data
          this.$refs.activationDialog.offlineRequest = true
          this.$refs.activationDialog.offlineRequestData = data.OfflineRequestData
        } else {
          this.snackbarMessage = data.StatusMessage
          this.snackbar = true
        }
      }

      if (data.TYPE === Models.ActionType.SYSTEM_ENV_PROCESS) {
        if (data.StatusCode === 200) {
          if (data.Data === '64') {
            this.is64Bit = true
          } else {
            this.is64Bit = false
          }
          // TEST ALWAYS IS 64
          this.is64Bit = true
        } else {
          this.snackbarMessage = data.StatusMessage
          this.snackbar = true
        }
      }

      if (data.TYPE === Models.ActionType.LOAD_FULL_IMAGE) {
        if (data.StatusCode === 200) {
          // update edited image, update base64
          console.log('finding image....is mobile:', data.Image.IsMobile)
          let found = null
          if (data.Image.IsMobile) {
            const mobFolder = this.mobileFolders.find(f => f.name === data.Image.MobileId)
            if (mobFolder !== undefined && mobFolder !== null) {
              found = mobFolder.files.find(file => file.Name === data.Image.Name)
            }
          } else {
            found = this.batch.Images.find((i) => {
              console.log(i.Name, data.Image.Name)
              if (i.Name === data.Image.Name) return i
            })
            if (found === null || found === undefined) {
              for (let i = 0; i < this.batch.Documents.length; ++i) {
                const doc = this.batch.Documents[i]
                found = doc.Images.find(di => {
                  console.log(di.Name, data.Image.Name)
                  if (di.Name === data.Image.Name) return di
                })
                console.log('sub found', found)
                if (found !== null && found !== undefined) break
              }
            }
          }
          if (found !== null && found !== undefined) {
            console.log('FULL IMAGE IMAGE FOUND', data.Image)
            found.Base64Full = data.Image.Base64Full
          }
        } else {
          this.snackbarMessage = data.StatusMessage
          this.snackbar = true
        }
      }

      if (data.TYPE === Models.ActionType.EDIT_IMAGE) {
        if (data.StatusCode === 200) {
          console.log('finding image....is mobile:', data.Image.IsMobile)
          let found = null
          if (data.Image.IsMobile) {
            const mobFolder = this.mobileFolders.find(f => f.name === data.Image.MobileId)
            if (mobFolder !== undefined && mobFolder !== null) {
              found = mobFolder.files.find(file => file.Name === data.Image.Name)
            }
          } else {
            found = this.batch.Images.find(i => i.Name === data.Image.Name)
            if (found === null || found === undefined) {
              for (let i = 0; i < this.batch.Documents.length; ++i) {
                const doc = this.batch.Documents[i]
                found = doc.Images.find(di => di.Name === data.Image.Name)
                if (found !== null && found !== undefined) break
              }
            }
          }
          console.log('EDIT_IMAGE FOUND:', found, data.Image, this.batch.Images)
          if (found !== null && found !== undefined) {
            found.Base64 = ''
            found.Base64Full = ''
            found.Base64 = data.Image.Base64
            found.Base64Full = data.Image.Base64Full
            found.Rotation = data.Image.Rotation
            found.Fields = data.Image.Fields
          }
        } else {
          this.snackbarMessage = data.StatusMessage
          this.snackbar = true
        }
      }

      if (data.TYPE === Models.ActionType.VERSION) {
        if (data.StatusCode === 200) {
          const res = this.compareVersions(window.Config.VERSION, '>', data.Data)
          // console.log('COMPARE VERSION', res)
          if (res === -1) {
            this.snackbarVersionText = this.$i18n.t('app.newversion')
            this.snackbarVersion = true
            this.tooltipVersion = true
            // eslint-disable-next-line brace-style
          }
          else {
            this.snackbarVersion = false
            this.tooltipVersion = false
          }
        }
      }

      if (data.TYPE === Models.ActionType.LOGS) {
        if (data.StatusCode === 200) {
          this.log = data.Data
        } else {
          this.snackbarMessage = data.StatusMessage
          this.snackbar = true
        }
      }

      if (data.TYPE === Models.ActionType.INSERT_USER) {
        if (data.StatusCode === 200) {
          this.snackbarMessage = data.StatusMessage
          this.snackbar = true
        }
      }

      if (data.TYPE === Models.ActionType.TWAIN_SOURCE_LIST || data.TYPE === Models.ActionType.TWAIN_SOURCE_RELOAD) {
        this.sourceCapLoader = false
        if (data.StatusCode === 200) {
          this.twain.Devices.splice(0, this.twain.Devices.length)
          this.twain.Devices.push(...data.Devices)
          if (data.Device !== null) {
            const found = this.twain.Devices.find(d => d.Name === data.Device.Name)
            if (found !== null && found !== undefined) {
              this.twain.DeviceName = data.Device.Name
              this.setDefaultDeviceSettings(found)
            }
          }
        } else {
          this.snackbarMessage = data.StatusMessage
          this.snackbar = true
        }
      }

      if (data.TYPE === Models.ActionType.TWAIN_SOURCE_CAP) {
        this.sourceCapLoader = false
        if (data.StatusCode === 200) {
          if (data.Device !== null) {
            const found = this.twain.Devices.find(d => d.Name === data.Device.Name)
            if (found !== null && found !== undefined) {
              console.log('Device FOUND! set new properties.....')
              // update found device
              console.log(JSON.stringify(found))
              Object.keys(found).forEach(function (key) {
                found[key] = data.Device[key]
                // Vue.set(found, key, data.Device[key])
              })
              console.log(JSON.stringify(found))
              if (this.twain.DeviceName === data.Device.Name) this.setDefaultDeviceSettings(found)
            }
          }
        } else {
          this.snackbarMessage = data.StatusMessage
          this.snackbar = true
        }
      }

      if (data.TYPE === Models.ActionType.LIST_BATCHES) {
        this.batchItems.splice(0, this.batchItems.length)
        data.ListBatches.sort((a, b) => {
          const dateA = Util.convertToDateObj(a.Date)
          const dateB = Util.convertToDateObj(b.Date)
          return dateB - dateA
        })
        this.batchItems.push(...data.ListBatches)
        if (data.ListBatches.length === 0) {
          this.cleanBatch()
        }
      }

      if (data.TYPE === Models.ActionType.DELETE_BATCH) {
        this.snackbarMessage = data.StatusMessage
        this.snackbar = true
        if (data.StatusCode === 200) {
          if (data.Batch.Id !== '') this.currentBatch = data.Batch.Id
        }
      }

      if (data.TYPE === Models.ActionType.DELETE_SCAN_IMAGE) {
        if (data.StatusCode === 200) {
          this.cleanDeletedImage()
          this.batch.IndexCount--
        } else {
          this.snackbarMessage = data.StatusMessage
          this.snackbar = true
        }
      }

      if (data.TYPE === Models.ActionType.NEW_SCAN_FROM_IMAGE) {
        const img = data.Image
        img.DocId = img.DocId.toString()
        this.batch.IndexCount++
        if (img.DocId !== '') {
          this.addImageScanInDocument(img)
        } else {
          this.setIndexes(img, this.batchTypes.Current.BatchSettings.Indexes)
          this.batch.Images.push(img)
        }
        console.log('EDITOR OPEN', this.$refs.editor.enable)
        if (this.$refs.editor.enable === true) {
          console.log(this.$refs.editor.image, img.DocId)
          if (this.$refs.editor.image.DocId.toString() === img.DocId.toString()) {
            this.$refs.editor.images.push(img)
          }
        }
        this.$swsa.emitProcess(Models.ActionType.NEW_SCAN_FROM_IMAGE)
      }

      if (data.TYPE === Models.ActionType.NEW_SCAN_IMAGE) {
        const img = data.Image
        img.DocId = img.DocId.toString()
        this.batch.IndexCount++
        if (img.DocId !== '') {
          this.addImageScanInDocument(img)
        } else {
          this.setIndexes(img, this.batchTypes.Current.BatchSettings.Indexes)
          this.batch.Images.push(img)
        }
        if (this.$refs.editor.enable === true) {
          if (this.$refs.editor.image.DocId.toString() === img.DocId.toString()) {
            this.$refs.editor.images.push(img)
          }
        }
        this.$swsa.emitProcess(Models.ActionType.NEW_SCAN_IMAGE)
        // this.updateLimit()
      }

      if (data.TYPE === Models.ActionType.LIMIT) {
        this.alert = true
        this.alertMessage = this.$i18n.t(data.StatusMessage)
        this.snackbarMessage = this.alertMessage
        this.snackbar = true
      }

      if (data.TYPE === Models.ActionType.IMPORT_FOLDER) {
        if (data.StatusCode === 500) {
          this.alert = true
          this.alertMessage = data.StatusMessage
        }
      }

      if (data.TYPE === Models.ActionType.MOBILE_SCAN) {
        this.mobileLoading = false
        if (data.StatusCode === 500) {
          this.alert = true
          this.alertMessage = data.StatusMessage
        } else {
          if (data.MobileId !== '') {
            const folder = this.mobileFolders.find(mf => mf.name === data.MobileId)
            if (folder !== undefined && folder !== null) {
              const mfolder = data.MobileFolders.find(mf => mf.name === data.MobileId)
              folder.files = mfolder.files
            }
          } else {
            this.mobileFolders = data.MobileFolders
            // remove infor about empty mobile scans
            /* if (this.mobileFolders.length === 0) {
              this.snackbar = true
              this.snackbarMessage = data.StatusMessage
            } */
          }
        }
      }

      if (data.TYPE === Models.ActionType.MFILES || data.TYPE === Models.ActionType.MFILES_DOWNLOAD) {
        this.mfiles.loading = false
        if (data.StatusCode === 500) {
          this.alert = true
          this.alertMessage = data.StatusMessage
        } else {
          this.mfiles.files = data.MFiles
          if (data.TYPE === Models.ActionType.MFILES_DOWNLOAD) {
            this.mfiles.dialog = false
          }
        }
      }

      if (data.TYPE === Models.ActionType.MOBILE_RESCAN) {
        this.mobileLoading = false
        if (data.StatusCode === 500) {
          this.alert = true
          this.alertMessage = data.StatusMessage
        } else {
          data.Images.forEach(img => {
            const folder = this.mobileFolders.find(mf => mf.name === img.MobileId)
            if (folder !== null && folder !== undefined) {
              const f = folder.files.find(f => f.Name === img.Name)
              if (f !== null && f !== undefined) {
                f.status = img.status
              }
            }
          })
        }
      }

      if (data.TYPE === Models.ActionType.MOBILE_SCAN_IMAGE_UPDATE) {
        if (data.StatusCode === 500) {
          this.alert = true
          this.alertMessage = data.StatusMessage
        } else {
          if (data.Image !== null || data.Image !== undefined) {
            let image = null
            image = this.batch.Images.find(img => img.Name === data.Image.Name)
            if (image !== null && image !== undefined) {
              console.log('found:', image)
              image.IsMobile = false
              image.Path = data.Image.Path
            }
            if (image === null || image === undefined) {
              this.batch.Documents.forEach((docs) => {
                if (image === null || image === undefined) {
                  image = docs.Images.find(img => img.Name === data.Image.Name)
                  if (image !== null && image !== undefined) {
                    console.log('found:', image)
                    image.IsMobile = false
                    image.Path = data.Image.Path
                  }
                }
              })
            }
          }
        }
      }

      if (data.TYPE === Models.ActionType.CREATE_BATCH_RESPONSE) {
        this.batchDialog = false
        this.batchDialogLoading = false
        this.snackbarMessage = data.StatusMessage
        this.snackbar = data.NoNotification ? false : true
        this.documentIndex.doc = null
        // this.documentIndex.indexesBoard = false
        this.documentIndex.selectValues = []
        if (data.StatusCode === 200) {
          this.setBatch(data.Batch)
          if (this.batchTypes.Current.BatchSettings.Indexes.length > 0) this.updateBatchInStorage()
          this.$swsa.emitProcess(Models.ActionType.CREATE_BATCH_RESPONSE)
        } else {
          this.alert = true
          this.alertMessage = data.StatusMessage
        }
      }

      if (data.TYPE === Models.ActionType.DEFAULT_BATCH || data.TYPE === Models.ActionType.SET_DEFAULT_BATCH) {
        if (data.StatusCode === 200) {
          if (this.batchTypes.Current.BatchSettings.Quick) {
            let newBatch = false
            if (this.isMonday === true && data.Batch.Exported && !this.initedBatch) {
              newBatch = true
              this.createBatch(null, true)
            }
            if (!newBatch && data.Batch.Exported && data.Batch.SessionId === this.batchTypes.Current.BatchSettings.SessionId && this.batchTypes.Current.BatchSettings.SessionId !== '') {
              this.systemInfoDialog = true
              this.systemInfoDialogMessage = data.StatusMessage + ' ' + this.$i18n.t('app.exportbatchendpend', [this.batch.Name, this.batch.SessionId])
            } else if (!newBatch && data.Batch.Exported && data.Batch.SessionId !== this.batchTypes.Current.BatchSettings.SessionId && !this.initedBatch) {
              // create auto batch
              newBatch = true
              this.createBatch(null, true)
            } else if (!newBatch && data.Batch.Exported && this.batchTypes.Current.BatchSettings.SessionId === '' && !this.initedBatch) {
              // create auto batch
              newBatch = true
              this.createBatch(null, true)
            }
            if (!newBatch) {
              this.setBatch(data.Batch)
            }
          } else {
            this.setBatch(data.Batch)
          }
          if (this.batchTypes.Current.BatchSettings.Indexes.length > 0) this.updateBatchInStorage()
          this.initedBatch = true
        } else if (data.StatusCode === 205) {
          this.removeMarkedImages(data.Images)
          this.batch.Documents.push(data.Document)
          this.batch.IndexCountDoc++
        } else {
          this.snackbarMessage = data.StatusMessage
          this.snackbar = true
        }
      }

      if (data.TYPE === Models.ActionType.INFO) {
        if (data.StatusCode === 502) {
          this.snackbarMessage = this.$i18n.t(data.StatusMessage, [data.Data])
          this.snackbar = true
        } else if (data.StatusCode === 501) {
          this.alertMessage = this.$i18n.t(data.StatusMessage, [data.Data])
          this.alert = true
        } else if (data.StatusCode === 505) {
          this.alertMessage = data.StatusMessage
          this.alert = true
        } else {
          if (data.StatusMessage.indexOf('Import Error') > -1) {
            this.sim.loading = false
          }
          this.snackbarMessage = data.StatusMessage
          this.snackbar = true
        }
      }

      if (data.TYPE === Models.ActionType.SYSTEM_INFO) {
        this.systemInfoDialogAction = true
        console.log(data)
        this.systemInfoDialog = true
        this.systemInfoDialogMessage = data.StatusMessage
        if (data.StatusCode === 403 || data.StatusCode === 401) {
          this.autoConnect = false
          if (data.StatusCode === 401) this.systemInfoDialogAction = false
          this.ws.close()
        } else if (data.StatusCode === 404) {
          this.batch.Documents = []
          this.batch.Images = []
          this.autoConnect = false
          this.ws.close()
        } else if (data.StatusCode === 405) {
          this.alert = true
          this.alertMessage = data.StatusMessage
        }
      }

      if (data.TYPE === Models.ActionType.UPLOAD_BATCH_PROGRESS) {
        if (data.Progress.Document !== null) {
          this.setDocumentProgress(data.Progress)
        } else if (data.Progress.Image !== null) {
          if (data.Progress.Image.Type === 'SCAN') {
            this.setImageProgress(data.Progress)
          } else {
            this.mobileLoading = true
          }
        }
      }

      if (data.TYPE === Models.ActionType.UPLOAD_BATCH_RESPONSE) {
        this.isExporting = false
        if (data.StatusCode === 200) {
          this.snackbarMessage = data.StatusMessage
          this.snackbar = true
          this.batch.UploadStatus = data.Batch.UploadStatus
          this.batch.Exported = data.Batch.Exported
          this.disableAction = false
          if (this.batchTypes.Current.ApplicationSettings.ExportSettings.CreateNewBatchAuto) {
            window.setTimeout(() => this.createBatch(null, true), 600)
          } else if (this.batchTypes.Current.ApplicationSettings.ExportSettings.CreateNewBatchDialog) {
            window.setTimeout(() => this.clickCreateBatch(null, false), 600)
          }
          if (this.batchTypes.Current.ApplicationSettings.ExportSettings.AutoCloseWindow) {
            try {
              window.close()
            } catch (err) {
              console.log('try close window after export', err)
            }
          }
          /* if (this.batchTypes.General.CreateBatchAuto) {
            window.setTimeout(() => this.createBatch(null, true), 600)
          } else {
            window.setTimeout(() => this.clickCreateBatch(null, false), 600)
          } */
          this.$swsa.emitProcess(Models.ActionType.UPLOAD_BATCH_RESPONSE)
        } else {
          this.disableAction = false
          // this.snackbarMessage = data.StatusMessage
          // this.snackbar = true
          this.cancelProgress()
          this.updateBatchInStorage()
          this.alert = true
          this.alertMessage = data.StatusMessage
        }
      }

      if (data.TYPE === Models.ActionType.EXPORT_CANCEL_DIALOG) {
        this.disableAction = false
        this.isExporting = false
      }

      if (data.TYPE === Models.ActionType.SIM_FILES) {
        if (data.StatusCode === 200) {
          this.sim.SimProjects = data.SimProjects
          this.sim.loading = false
        } else {
          this.alert = true
          this.alertMessage = data.StatusMessage
        }
      }

      if (data.TYPE === Models.ActionType.SIM_FILES_DOWNLOAD) {
        if (data.StatusCode === 200) {
          this.sim.loading = false
        } else {
          this.alert = true
          this.alertMessage = data.StatusMessage
        }
      }

      if (data.TYPE === Models.ActionType.MONDAY_FILES_DOWNLOAD) {
        this.monday.item.loading = false
        if (data.StatusCode === 200) {
          this.monday.item.assets.forEach((a) => {
            const ad = data.MondayAssets.find(ai => ai.id === a.id)
            if (ad) {
              a.downloaded = ad.downloaded
              this.$refs.mondayFilesDialog.unselectAll()
            }
          })
          this.monday.item.hasDownloadError = false
          this.monday.item.errorAsstes = []
          this.monday.item.dialog = false
        } else {
          this.alert = true
          this.alertMessage = data.StatusMessage
        }
      }

      if (data.TYPE === Models.ActionType.MONDAY_FILES_DOWNLOAD_CONFIRM) {
        this.monday.item.loading = false
        if (data.StatusCode === 200) {
          this.monday.item.hasDownloadError = true
          this.monday.item.errorAsstes = data.MondayAssets
          this.monday.item.dialog = true
        } else {
          this.alert = true
          this.alertMessage = data.StatusMessage
        }
      }

      if (data.TYPE === Models.ActionType.EXPORT_BATCH_RESPONSE) {
        this.isExporting = false
        this.mobileLoading = false
        if (data.StatusCode === 200) {
          this.batch.UploadStatus = data.Batch.UploadStatus
          this.batch.Exported = data.Batch.Exported
          if (this.batchTypes.Current.BatchSettings.Quick) {
            this.systemInfoDialog = true
            this.systemInfoDialogMessage = data.StatusMessage + ' ' + this.$i18n.t('app.exportbatchendpend', [this.batch.Name, this.batch.SessionId])
          } else {
            this.snackbarMessage = data.StatusMessage
            this.snackbar = true
          }
          this.disableAction = false
          // ExportSettings.CreateNewBatchDialog
          console.log('NEWBATCH', this.batchTypes.Current.ApplicationSettings.ExportSettings.CreateNewBatchAuto, this.batchTypes.Current.ApplicationSettings.ExportSettings.CreateNewBatchDialog)
          if (this.batchTypes.Current.ApplicationSettings.ExportSettings.CreateNewBatchAuto) {
            window.setTimeout(() => this.createBatch(null, true), 600)
          } else if (this.batchTypes.Current.ApplicationSettings.ExportSettings.CreateNewBatchDialog) {
            window.setTimeout(() => this.clickCreateBatch(null, false), 600)
          }
          if (this.batchTypes.Current.ApplicationSettings.ExportSettings.AutoCloseWindow) {
            try {
              // window.open(window.location, '_self').close()
              window.close('', '_parent', '')
            } catch (err) {
              console.log('try close window after export', err)
            }
          }
          /* if (this.batchTypes.General.CreateBatchAuto) {
            window.setTimeout(() => this.createBatch(null, true), 600)
          } else {
            window.setTimeout(() => this.clickCreateBatch(null, false), 600)
          } */
          this.$swsa.emitProcess(Models.ActionType.EXPORT_BATCH_RESPONSE)
        } else {
          this.disableAction = false
          // this.snackbarMessage = data.StatusMessage
          // this.snackbar = true
          this.cancelProgress()
          this.updateBatchInStorage()
          this.alert = true
          this.alertMessage = data.StatusMessage
        }
      }

      if (data.TYPE === Models.ActionType.NEW_DOCUMENT) {
        this.documentCount++
        this.setIndexes(data.Document, this.batchTypes.Current.BatchSettings.Indexes)
        this.batch.Documents.push(data.Document)
        this.$swsa.emitProcess(Models.ActionType.NEW_DOCUMENT)
      }

      if (data.TYPE === Models.ActionType.MFILES_DOWNLOAD_PROGRESS) {
        // eslint-disable-next-line no-unneeded-ternary
        this.mfilesDownloading = (data.StatusCode === 0) ? true : false
      }
    },
    setValidUploadParams () {
      console.log('setValidUploadParams', this.batchTypes.General.SimSettings.IsSimLite)
      this.uploadValid.valid = true
      if (this.batchTypes.General.SimSettings.IsSimLite) {
        this.requiredRequestParamsLite.forEach((p) => {
          const found = this.BatchParams.find(rp => rp.Name === p)
          if (!found) {
            this.uploadValid.p.push(p)
            this.uploadValid.valid = false
          }
        })
      } else {
        this.requiredRequestParams.forEach((p) => {
          const found = this.BatchParams.find(rp => rp.Name === p)
          if (!found) {
            this.uploadValid.p.push(p)
            this.uploadValid.valid = false
          }
        })
      }
    }
  },
  created () {
    console.log('Created APP and set user GUID')
    let guid = ''
    if (window.localStorage.getItem('userGuid') === null) {
      guid = this.getUID()
      window.localStorage.setItem('userGuid', guid)
    } else {
      guid = window.localStorage.getItem('userGuid')
    }
    this.userGuid = guid
    if (window.localStorage.getItem('thumbCols') !== null) {
      this.thumbCols = window.localStorage.getItem('thumbCols')
    }
    useSnackInfo.app = this
    useMetaLicense.app = this
    this.primaryColor = this.$vuetify.theme.themes.light.primary
    this.isIE11 = !!window.MSInputMethodContext && !!document.documentMode
    this.isFireFox = window.navigator.userAgent.indexOf('Firefox') > -1
    console.log('IsIE11:', this.isIE11)
    console.log('IsFireFox:', this.isFireFox)
    // console.log(this.$vuetify.theme.themes.light)
    // console.log(this.$vuetify.theme.themes.dark)
    // SETUP VERSION
    const Config = {
      PORT: '7788',
      VERSION: '1.3.6',
      CCLIENT: '',
      PROTOCOL: 'swebscan://run'
    }
    const loc = new URL(window.location.href)
    loc.pathname = loc.pathname + '/'
    loc.pathname = loc.pathname.replace('//', '/')
    console.log(loc)
    Config.CCLIENT = loc.protocol + '//' + loc.host + loc.pathname + 'SWebScanInstaller' + '.exe?uncache=' + this.getUID()
    console.log('CCLIENT', Config.CCLIENT)
    window.Config = Config
    // END SETUP VERSION
    const queryString = window.location.search
    let urlParams = new URLSearchParams(queryString)
    Monday.app = this
    Monday.getMondayContext(urlParams)
    console.log('VUE_APP_MONDAY:', this.isMonday)
    let jsonHash = urlParams.get('p')
    console.log('JASON_HASH', jsonHash)
    if (jsonHash !== null && jsonHash !== undefined && jsonHash !== '') {
      const codec = JsonURL('lzma')
      codec.decompress(jsonHash).then(json => {
        console.log('JSON URL', json, JSON.stringify(json))
        this.jsonUrlData = json
        const parser = new JsonURLParser(this, this.batchTypes, json)
        parser.parseJSON()
      }).catch(error => {
        console.log('JSON error:', error)
      })
    }

    // TRY GET JAVA URL PARAMETER END DECODE IT
    if (jsonHash === null || jsonHash === undefined || jsonHash === '') {
      urlParams = new URLSearchParams(queryString)
      jsonHash = urlParams.get('j')
      if (jsonHash !== null && jsonHash !== undefined && jsonHash !== '') {
        let json = decompressUrlSafe(jsonHash)
        console.log('JAVA JSON STRING', json)
        json = JSON.parse(json)
        console.log(json)
        this.jsonUrlData = json
        const parser = new JsonURLParser(this, this.batchTypes, json)
        parser.parseJSON()
      }
    }
    this.barcodeItems.push(...Models.BarcodeTypes)
    this.setDefaultLanguage()
    try {
      this.openWs()
    } catch(err) {
      console.warn('openWs', err)
    }
    window.addEventListener('keydown', (ev) => {
      // console.log('keydown', ev)
      if (ev.ctrlKey) {
        this.ctrlKey = true
      }
      if (ev.shiftKey) {
        this.shiftKey = true
      }
    })
    window.addEventListener('keyup', (ev) => {
      // console.log('keyup', ev)
      if (ev.keyCode === 17) {
        this.ctrlKey = false
      }
      if (ev.keyCode === 16) {
        this.shiftKey = false
      }
    })
    window.addEventListener('resize', (ev) => {
      window.setTimeout(this.windowResize, 500)
    })

    window.setTimeout(() => {
      // check if quick mode is true, if its true than open scan board
      this.twain.ScanBoard = this.batchTypes.Current.BatchSettings.Quick
      if (this.twain.ScanBoard) this.changeScanType(this.IModels.VIEW_SCAN_TYPE.QUICK_SCAN)
      // quick mode END
      Dropzone.autoDiscover = false
      Dropzone.autoProcessQueue = false
      const fileDropzone = new Dropzone('#dropfile', {
        url: '/',
        autoProcessQueue: false,
        acceptedFiles: '.tif, .tiff, .pdf, .jpg, .jpeg, .png, .bmp, .gif, .xml'
      })
      fileDropzone.autoProcessQueue = false
      fileDropzone.on('addedfile', (file) => {
        this.dropFileCount++
        if (file.dataURL === undefined || file.dataURL === '') {
          const reader = new FileReader()
          reader.addEventListener('load', (event) => {
            console.log('load drop file', event)
            const result = event.target.result
            this.dropFiles.push({ data: result, name: file.name })
            this.dropFileCountLoaded++
            if (this.dropFileCount === this.dropFileCountLoaded) {
              const action = Models.Action
              action.TYPE = Models.ActionType.EXTRACT_DOCUMENT
              action.ExtractData = this.dropFiles
              action.Device = this.twain.Device
              action.DocClass = this.getDefaultClass(null)
              action.SessionId = this.batchTypes.Current.BatchSettings.SessionId
              action.BatchTypes = this.batchTypes
              this.ws._send(JSON.stringify(action))
              this.dropFiles.splice(0, this.dropFiles.length)
            }
          })
          reader.readAsDataURL(file)
        }
      })
    }, 1500)
  },
  watch: {
    'batchTypes.Current': function (newVal, oldVal) {
      this.setForceImportScan()
    },
    'batch.Documents': function (n, o) {
      this.documentPanelsOpenIndicator2 = []
      for (let i = 0; i < this.batch.Documents.length; ++i) { this.documentPanelsOpenIndicator2.push(i) }
    },
    thumbCols: function (newVal) {
      window.localStorage.setItem('thumbCols', newVal)
    }
  }
}
</script>

<style lang="sass">
  @import '../node_modules/typeface-roboto/index.css'
</style>

<style scoped>
.separator {
  width: 0.5em;
  height: 100%;
  float: left;
  background-color: rgb(179, 212, 252);
  position: absolute;
  top: 0;
  left: calc(100% + 0.5em);
  margin: 0;
  padding: 0;
  border-radius: 5px;
  opacity: 0.1;
  z-index: 100;
  cursor: pointer;
}

.separator:hover {
  opacity: 1 !important;
}

.redP {
  color: red;
  font-weight: bolder;
  font-style: italic;
  padding-right: 10px;
}

.selecti {
  background-color: #14248a;
  opacity: .2;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 100;
}

.systemp {
  font-size: 12px !important;
  color:white !important;
  margin-top: 4px !important;
}

.systemprop {
  font-weight: bolder;
  font-style: normal;
  text-transform: uppercase;
}

.svgfill {
  fill: white;
}

.svgThumbFill {
  fill: grey;
}
</style>

<style>
.dz-preview {
  display: none !important;
}
.dz-file-preview {
  display: none !important;
}

.v-input__slider > .v-input__control {
  height: 40px;
}

.v-slider__thumb:after {
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    content: "";
    color: inherit;
    width: 12px !important;
    height: 12px !important;
    border-radius: 50%;
    background: currentColor;
    opacity: 0.3;
    position: absolute;
    left: 0px !important;
    top: 0px !important;
    transform: scale(0.1);
    pointer-events: none;
}

.v-slider__thumb:before {
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    content: "";
    color: inherit;
    width: 12px !important;
    height: 12px !important;
    border-radius: 50%;
    background: currentColor;
    opacity: 0.3;
    position: absolute;
    left: 0px !important;
    top: 0px !important;
    transform: scale(0.1);
    pointer-events: none;
}

#panelSingle > .v-expansion-panel-content__wrap {
  background-color: antiquewhite;
}
</style>
